<template>
  <div class="page_tePaymentDtl">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con" v-if="!loading">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>日志报销</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/logReimbursement',query:{
            activeName,tabName
          } }">{{tabName}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{type=='dtl' ? '详情' : type=='add' ? '填写报销单' : type=='edit' ? '编辑' : '审批'}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName3" type="card" v-if="type=='approve'">
          <el-tab-pane label="审批内容" name="0"></el-tab-pane>
          <el-tab-pane label="工作流" name="1"></el-tab-pane>
          <el-tab-pane label="流程记录" name="2"></el-tab-pane>
        </el-tabs>
        <div v-if="activeName3=='0'">
          <!-- 报销单 -->
          <div class="reimbursementBox">
            <el-form :model="reiForm" v-if="type!='batchPrint'">
              <el-form-item label="报销人:" v-if="type=='add'">
                <div class="flex aic">
                  <!-- <el-cascader ref="cascaderArrDep" v-model="reiForm.depName" :props="props" clearable placeholder="选择部门" filterable :options="departmentList" style="width: 180px;margin-right:15px" size="small" :show-all-levels="false" @change="changeDep"></el-cascader> -->
                  <el-select v-model="written" placeholder="选择人员" clearable size="small" value-key="userid" style="width: 180px;margin-right:15px" filterable @change="changeUser">
                    <el-option v-for="(item,index) in customerList" :key="index" :label="item.username" :value="item"></el-option>
                  </el-select>
                  <el-date-picker type="month" placeholder="" v-model="listQuery.applyMonth" value-format="yyyy-MM" style="width:180px;margin-right:10px" size="small" :clearable="false" @change="changeApplyMonth"></el-date-picker>
                  <!-- <el-date-picker type="month" placeholder="" v-model="timeEnd" value-format="yyyy-MM" style="width:180px" size="small" :clearable="false" @change="changeApplyMonth"></el-date-picker> -->
                </div>
              </el-form-item>
              <el-form-item label="报销人:" v-else>
                <!-- <span>{{depName}}</span> -->
                <span style="margin-left:10px">{{reiForm.writtenName}}</span>
                <span style="margin-left:30px">经办人： {{reiForm.writtenName}}</span>
              </el-form-item>

            </el-form>

            <div class="verRecBox" v-if="type!='batchPrint'">
              <div class="Reititle"><span class="titleLine">|</span> 日志记录</div>
              <el-table :data="logData" border class="doc_table" style="width:860px;margin-top:10px" max-height="400px">
                <el-table-column prop="applyTime" label="日志日期" min-width="100" :show-overflow-tooltip="true" align="center">
                  <template slot-scope={row}>{{row.applyTime ? row.applyTime.split('T')[0] : ''}}</template>
                </el-table-column>
                <el-table-column prop="advanceNum" label="日志编号" min-width="160" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="advanceType" label="费用类别" min-width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="totalFees" label="日志金额" min-width="100" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="sevrvceDeptName" label="服务部门" min-width="140" :show-overflow-tooltip="true" align="center">
                </el-table-column>
                <el-table-column prop="descFees" label="说明" min-width="200" :show-overflow-tooltip="true" align="center">
                </el-table-column>
              </el-table>

              <div v-if="logData.length>0" class="logAmount">日志金额合计:￥{{ logAmount}}</div>
            </div>
            <div class="flex aic jcb" style="margin-bottom:10px">
              <div class="flex aic">
                <div class="Reititle"><span class="titleLine">|</span> {{type=='add' || type=='edit' ? '填写报销单' : '报销单'}}</div>
                <span class="printNoTxt" :title="printNo" v-if="printNo &&type=='batchPrint'">当前打印编号：{{ printNoText }}</span>
              </div>
              <div class="flex aic" v-if="reiEditable">
                <el-button size="small" type="success" @click="showInvoiceImport = true" style="margin-left:15px;border-radius:14px;font-weight:600">+导入发票自动生成</el-button>
                <i class="el-icon-question" style="margin-left:10px;color:#409EFF;font-size:16px"></i>
                <span style="margin-left:6px;font-size:12px;color:#606266">提示：导入发票凭证批量上传电子发票，系统按发票抬头自动填写法务主体、按开票内容预选费用科目，自动拆分生成报销单</span>
              </div>
            </div>
            <div v-if="failPrintFiles.length" style="color:#F56C6C;font-size:12px;line-height:20px;margin:0 0 8px">
              <i class="el-icon-warning"></i>
              {{ failPrintFiles.length }} 个PDF发票凭证未能并入打印，请点击发票凭证列表中的「预览」单独打印：{{ failPrintFiles.join('、') }}
            </div>
            <div class="reiTableBox" v-show="type!='dtl' && type!='batchPrint'">
              <el-form :inline="true" :model="reiForm">
                <el-form-item label="报销日期:">
                  <el-date-picker type="date" placeholder="" v-model="reiForm.reimbTime" value-format="yyyy-MM-dd" style="width:150px" size="small"></el-date-picker>
                </el-form-item>
                <el-button size="small" type="primary" @click="openAllInvoiceList" v-if="type=='approve' && tabName == '财务审核'" style="margin-left:630px;border-radius:14px;font-weight:600">查看全部发票凭证</el-button>
              </el-form>
              <!-- 无纸化报销单列表 -->
              <div class="wzFormBox">
                <div class="wzForm" v-for="(item,index) in writeOffData" :key="index">
                  <div class="wzFormHead flex aic jcb">
                    <div class="flex aic">
                      <i :class="item.collapsed ? 'el-icon-arrow-right' : 'el-icon-arrow-down'" class="cp" @click="toggleForm(index)"></i>
                      <span class="wzFormNo">报销单{{index + 1}}</span>
                      <el-tag size="mini" effect="plain" type="info">草稿</el-tag>
                      <span class="wzFormMeta">行数：{{item.reiData.length}}</span>
                      <span class="wzFormMeta">发票 {{pageInvoiceCount(item)}} 张</span>
                      <span class="wzFormMeta">合计 {{pageAmount(item)}} 元</span>
                    </div>

                  </div>
                  <div v-show="!item.collapsed">
                    <div class="wzMetaRow flex aic">
                      <div class="flex aic"><span class="required">*</span>发票抬头：
                        <el-select v-model="item.companyName" placeholder="" size="small" style="width:300px" clearable filterable>
                          <el-option v-for="(c,i) in legList" :key="i" :label="c.name" :value="c.name"></el-option>
                        </el-select>
                      </div>

                      <div class="flex aic">
                        <span style="font-size:12px;color:#606266;margin:0 8px 0 20px">凭证类型</span>
                        <el-select v-model="item.voucherType" placeholder="" size="small" style="width:120px;margin-right:20px" clearable filterable>
                          <el-option value="电子" label="电子"></el-option>
                          <el-option value="纸质" label="纸质"></el-option>
                        </el-select>
                        <!-- <el-button type="text" @click="delPage(index)">删除本页</el-button> -->
                      </div>
                      <!-- <div class="flex aic" style="margin-left:20px">报销人：
                        <el-input v-model="item.reimbUserName" size="small" placeholder="请输入" style="width:120px"></el-input>
                      </div> -->
                    </div>
                    <!-- 电子凭证三项不合格提示（后端按发票识别内容标记）：凭证内容与报销类目不符 / 填写金额大于识别金额 / 我方公司主体信息缺失或不清晰或不符 -->
                    <!-- <div v-if="pageWarnings(item).length" class="flex aic flexW" style="margin:4px 20px">
                      <template v-for="w in pageWarnings(item)">
                        <div :key="'w' + w" class="flex aic" style="margin-right:18px">
                          <i class="el-icon-warning" style="color:#E6A23C;font-size:14px"></i>
                          <span style="font-size:12px;color:#E6A23C;margin-left:4px">提示：{{w}}</span>
                        </div>
                      </template>
                    </div> -->
                    <el-table :data="item.reiData" border size="mini" class="wzTable">
                      <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
                      <el-table-column label="发生日期" width="150" align="center">
                        <template slot-scope="scope">
                          <el-date-picker type="date" placeholder="" v-model="scope.row.occurDate" value-format="yyyy-MM-dd" style="width:125px" size="mini"></el-date-picker>
                        </template>
                      </el-table-column>
                      <el-table-column label="报销内容" min-width="150">
                        <template slot-scope="scope">
                          <div class="flex aic">
                            <el-select v-model="scope.row.reimbursementContent" placeholder="请选择" clearable filterable size="mini" style="width:calc(100% - 22px)">
                              <el-option v-for="(c,i) in teContList" :key="i" :value="c.name"></el-option>
                            </el-select>
                            <el-tooltip v-if="scope.row.subjectFlag" :content="scope.row.subjectFlag" placement="top">
                              <i class="el-icon-warning wzWarnIcon"></i>
                            </el-tooltip>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="备注" min-width="130">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.remark" size="mini" placeholder="选填" style="width:110px"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="单据张数" width="90" align="center">
                        <template slot-scope="scope">
                          <el-input-number size="mini" v-model="scope.row.documentsNum" :min="1" :max="99" style="width:66px" :controls="false" @change="syncDocumentsNum(scope.row)"></el-input-number>
                        </template>
                      </el-table-column>
                      <el-table-column label="报销金额" width="130">
                        <template slot-scope="scope">
                          <div class="flex aic">
                            <el-input type="number" v-model="scope.row.amounts" size="mini" style="width:calc(100% - 22px)" @blur="checkRowAmount(scope.row)"></el-input>
                            <el-tooltip v-if="scope.row.amountFlag" :content="scope.row.amountFlag" placement="top">
                              <i class="el-icon-warning wzWarnIcon"></i>
                            </el-tooltip>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column label="发票号码" min-width="200" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                          <el-input size="mini" v-model="scope.row.invoiceNum" placeholder="无" @blur="syncInvoiceNos(scope.row)"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" width="170" align="center">
                        <template slot-scope="scope">
                          <el-button type="text" size="mini" @click="openInvoiceList(index, scope.$index)" v-if="item.voucherType=='电子'">
                            发票凭证
                          </el-button>
                          <el-button type="text" size="mini" @click="delLine(item,index,scope.$index)">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                    <!-- <div class="flex aic" style="margin:8px 0">
                      <el-button type="text" icon="el-icon-plus" @click="addRow(index)">新增一行</el-button>
                      <span class="wzTip">每张报销单最多 6 行，金额不能大于该行发票金额合计</span>
                    </div> -->
                  </div>
                </div>
              </div>
              <div class="flex reiTableBot">
                <div class="flex aic cp" style="margin-left:30px" @click="addPage">
                  <i class="el-icon-circle-plus icon01"></i>
                  <el-button type="text" style="margin-left:5px">新增一页</el-button>
                </div>
                <el-button type="text" style="margin-left:40px" @click="complete">完成</el-button>
              </div>
            </div>
            <!-- 导入发票凭证 -->
            <el-dialog title="导入发票凭证" :visible.sync="showInvoiceImport" width="500px" append-to-body>
              <!-- <div class="flex aic" style="margin-bottom:10px">
                <span style="font-size:13px;color:#606266;margin-right:8px">识别引擎</span>
                <el-radio-group v-model="ocrEngine" size="small">
                  <el-radio label="deepseek">DeepSeek大模型（购销方更全，较慢）</el-radio>
                </el-radio-group>
              </div> -->
              <div class="wzUploadBox">
                <el-upload class="wzUpload" drag action="" multiple :auto-upload="false" :file-list="ocrFileList" :on-change="handleOcrFile" :on-remove="handleOcrFileRemove" accept=".pdf,.jpg,.jpeg,.png,.bmp,.ofd,.zip,.rar">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将发票文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">支持 pdf / 图片 / ofd，也可整包 zip、rar 上传，单个不超过 10M</div>
                </el-upload>
                <!-- <div class="wzUploadManual" @click="addPage">
                  <i class="el-icon-circle-plus-outline"></i>
                  <div>手工新增一页（手工填入票据信息）</div>
                </div> -->
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showInvoiceImport = false">取消</el-button>
                <el-button size="small" type="primary" :loading="ocrLoading" @click="startOcr">开始上传并识别</el-button>
              </span>
            </el-dialog>

            <!-- 发票识别结果 -->
            <el-dialog title="发票识别结果" :visible.sync="ocrPreview.visible" width="1100px" append-to-body>
              <div class="wzResultTitle">有效发票（{{ocrPreview.validList.length}}）</div>
              <el-table :data="ocrPreview.validList" border size="mini" max-height="300" style="width:99%" @selection-change="validSelChange">
                <el-table-column type="selection" width="45" align="center" fixed="left"></el-table-column>
                <el-table-column type="index" label="#" width="50" align="center" fixed="left"></el-table-column>
                <el-table-column prop="no" label="发票号码" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="date" label="开票日期" min-width="100"></el-table-column>
                <el-table-column prop="seller" label="销售方" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="buyer" label="发票抬头（主体）" min-width="150" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="报销金额（元）" min-width="115" align="right">
                  <template slot-scope="scope">{{ formatMoney(scope.row.originalAmount) }}</template>
                </el-table-column>
                <el-table-column label="税额（元）" min-width="100" align="right">
                  <template slot-scope="scope">
                    <span v-if="scope.row.taxAmount != null && scope.row.taxAmount !== ''">{{ formatMoney(scope.row.taxAmount) }}</span>
                    <span v-else style="color:#909399">-</span>
                    <div v-if="scope.row.taxRemark" style="color:#909399;font-size:12px;line-height:1.2" :title="scope.row.taxRemark">{{ scope.row.taxRemark }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="本次核销金额" min-width="110">
                  <template slot-scope="scope">
                    <el-input type="number" size="mini" v-model="scope.row.amount" @blur="checkOcrAmount(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="费用科目" min-width="130" align="center">
                  <template slot-scope="scope">
                    <el-select size="mini" v-model="scope.row.costName" filterable clearable placeholder="选择科目">
                      <el-option v-for="(c,i) in teContList" :key="i" :label="c.name" :value="c.name"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="发票品名" min-width="160">
                  <template slot-scope="scope">
                    <el-input type="text" size="mini" v-model="scope.row.projectName"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="发票类别" min-width="130">
                  <template slot-scope="scope">
                    <el-input type="text" size="mini" v-model="scope.row.invoiceType"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="状态" min-width="68" align="center" fixed="right">
                  <template slot-scope="scope">
                    <span v-if="scope.row.usedMsg" style="color:#F56C6C" :title="scope.row.usedMsg">已被使用</span>
                    <span v-else style="color:#67C23A">可用</span>
                    <div v-if="scope.row.notice" style="color:#E6A23C;font-size:12px" :title="scope.row.notice">待核对</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="60" align="center" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" :disabled="!scope.row.fileUrl" @click="invoicePreview(scope.row)">预览</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="ocrPreview.validList.length > 0" style="margin:8px 0;padding:8px 12px;background:#f5f7fa;border-radius:4px;font-size:13px;line-height:26px">
                <span>统计：<b>{{ ocrSummary.fromSelection ? '已勾选' : '全部有效' }}</b> {{ ocrSummary.count }} 张</span>
                <span style="margin-left:16px">报销总金额：<b style="color:#F56C6C">¥{{ formatMoney(ocrSummary.amount) }}</b></span>
                <span style="margin-left:16px">税额总金额：<b style="color:#E6A23C">¥{{ formatMoney(ocrSummary.tax) }}</b></span>
                <span v-for="(v,k) in ocrSummary.byCost" :key="k" style="margin-left:8px">
                  <el-tag size="mini" effect="plain">{{ k }}：¥{{ formatMoney(v.amount) }}<template v-if="v.tax"> / 税 ¥{{ formatMoney(v.tax) }}</template></el-tag>
                </span>
              </div>
              <div class="wzResultTitle wzResultTitle2">无效发票（{{ocrPreview.invalidList.length}}）</div>
              <el-table :data="ocrPreview.invalidList" border size="mini" max-height="200" style="width:99%">
                <el-table-column type="index" label="#" width="50" align="center"></el-table-column>
                <el-table-column prop="no" label="发票号码" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="date" label="开票日期" min-width="100"></el-table-column>
                <el-table-column prop="seller" label="销售方" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column prop="buyer" label="发票抬头（主体）" min-width="140" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column label="报销金额（元）" min-width="115" align="right">
                  <template slot-scope="scope">{{ formatMoney(scope.row.originalAmount) }}</template>
                </el-table-column>
                <el-table-column label="税额（元）" min-width="90" align="right">
                  <template slot-scope="scope">
                    <span v-if="scope.row.taxAmount != null && scope.row.taxAmount !== ''">{{ formatMoney(scope.row.taxAmount) }}</span>
                    <span v-else style="color:#909399">-</span>
                  </template>
                </el-table-column>
                <el-table-column label="费用科目" min-width="90" align="center">
                  <template slot-scope="scope">
                    <span v-if="!scope.row.costName || scope.row.costName == '待定'" style="color:#E6A23C">待定</span>
                    <span v-else>{{ scope.row.costName }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="invalidReason" label="异常原因" min-width="160" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    <span style="color:#F56C6C">{{ scope.row.invalidReason }}</span>
                    <div v-if="scope.row.fileName" style="color:#909399;font-size:12px">{{ scope.row.fileName }}</div>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="150" align="center">
                  <template slot-scope="scope">
                    <el-button type="text" size="mini" :disabled="!scope.row.fileUrl" :loading="scope.row.reOcring" @click="reOcrByDeepSeek(scope.row)">
                      用DeepSeek重识别
                    </el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top:10px">
                <el-checkbox v-model="ocrPreview.autoSplit">识别完成后自动按 凭证类型 + 发票抬头 + 费用科目 拆表</el-checkbox>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="ocrPreview.visible = false">取消</el-button>
                <el-button size="small" type="primary" @click="confirmImportInvoice">确认导入（{{ocrPreview.selection.length}}）</el-button>
              </span>
            </el-dialog>

            <!-- 单行的发票凭证列表 -->
            <el-dialog :visible.sync="invoiceList.visible" width="900px" append-to-body custom-class="invListDialog">
              <div slot="title" class="invDlgTitle">
                发票凭证
                <span v-if="invoiceCostName"> · {{ invoiceCostName()}}</span>
              </div>
              <div class="invHeaderCard">
                <div class="invHeaderTop">
                  <span>报销人：{{ invoiceCurrentPage().reimbUserName || reiForm.writtenName || '-' }}</span>
                  <span class="sep">|</span>
                  <span>法务主体：{{ invoiceCurrentPage().entityName || '-' }}</span>
                  <span class="sep">|</span>
                  <span>凭证类型：{{ invoiceCurrentPage().voucherType || '-' }}</span>
                  <span class="sep">|</span>
                  <span>本行科目：{{ invoiceCostName() || '-' }}</span>
                </div>
                <div class="invHeaderSum">
                  已上传 <b>{{ invoiceList.rows.length }}</b> 张发票凭证，报销合计 <b style="color:#F56C6C">¥{{ formatMoney(invoiceSum('amount')) }}</b>（识别金额合计 ¥{{ formatMoney(invoiceSum('originalAmount')) }}），税额合计 <b style="color:#E6A23C">¥{{ formatMoney(invoiceSum('taxAmount')) }}</b>
                </div>
              </div>
              <div class="invHint">
                <i class="el-icon-warning-outline"></i>
                每张发票的报销金额可直接修改，但不得超过其识别金额。
              </div>
              <div class="invCardList">
                <div v-for="(row, i) in invoiceList.rows" :key="i" class="invCard">
                  <div class="invBadge">票</div>
                  <div class="invMain">
                    <div class="invSeller">{{ row.seller }}</div>
                    <div class="invMeta">
                      <span>{{ row.no }}</span>
                      <span>{{ row.date }}</span>
                      <span>抬头：{{ row.buyer }}</span>
                      <span v-if="row.projectName" :title="row.projectName">品名：{{ row.projectName }}</span>
                      <span v-if="row.invoiceType" :title="row.invoiceType">类别：{{ row.invoiceType }}</span>
                      <el-select size="mini" v-model="row.costName" filterable clearable placeholder="费用科目" style="width:130px">
                        <el-option v-for="(c,i) in teContList" :key="i" :label="c.name" :value="c.name"></el-option>
                      </el-select>
                      <span v-if="row.taxAmount != null && row.taxAmount !== ''" style="color:#E6A23C">税额 ¥{{ formatMoney(row.taxAmount) }}</span>
                      <span v-if="row.taxRemark" style="color:#909399;font-size:12px" :title="row.taxRemark">{{ row.taxRemark }}</span>
                    </div>
                  </div>
                  <div class="invAmount">
                    <el-input type="number" size="small" v-model="row.amount" @blur="checkInvoiceAmount(row)"></el-input>
                    <span class="invOrig">/ ¥{{ formatMoney(row.originalAmount) }}</span>
                  </div>
                  <div class="invOps">
                    <el-button type="text" size="mini" @click="invoicePreview(row)">预览</el-button>
                    <el-button type="text" size="mini" style="color:#F56C6C" @click="delInvoice(i)">删除</el-button>
                  </div>
                </div>
                <div v-if="invoiceList.rows.length == 0" class="invEmpty">暂无发票凭证</div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="saveInvoiceList">关闭</el-button>
                <el-button size="small" type="primary" @click="importInvoice">+ 上传发票凭证</el-button>
              </span>
            </el-dialog>

            <!-- 财务审核：汇总查看所有报销单的发票凭证（只读） -->
            <el-dialog :visible.sync="allInvoiceList.visible" width="900px" append-to-body custom-class="invListDialog">
              <div slot="title" class="invDlgTitle">全部发票凭证</div>
              <div class="invHeaderCard">
                <div class="invHeaderTop">
                  <span>报销人：{{ reiForm.writtenName || '-' }}</span>
                  <span class="sep">|</span>
                  <span>报销单：{{ writeOffData.length }} 张</span>
                  <span class="sep">|</span>
                  <span>发票：{{ allInvoiceList.rows.length }} 张</span>
                </div>
                <div class="invHeaderSum">
                  报销合计 <b style="color:#F56C6C">¥{{ formatMoney(allInvoiceSum('amount')) }}</b>（识别金额合计 ¥{{ formatMoney(allInvoiceSum('originalAmount')) }}），税额合计 <b style="color:#E6A23C">¥{{ formatMoney(allInvoiceSum('taxAmount')) }}</b>
                </div>
              </div>
              <div class="invCardList">
                <div v-for="(row, i) in allInvoiceList.rows" :key="i" class="invCard">
                  <div class="invBadge">票</div>
                  <div class="invMain">
                    <div class="invSeller">{{ row.seller }}</div>
                    <div class="invMeta">
                      <span>{{ row.no }}</span>
                      <span>{{ row.date }}</span>
                      <span>抬头：{{ row.buyer }}</span>
                      <el-tag size="mini" effect="plain">报销单{{ row._pageNo }}·行{{ row._rowNo }}</el-tag>
                      <span v-if="row._subject">科目：{{ row._subject }}</span>
                      <span v-if="row.projectName" :title="row.projectName">品名：{{ row.projectName }}</span>
                      <span v-if="row.invoiceType" :title="row.invoiceType">类别：{{ row.invoiceType }}</span>
                      <span v-if="row.taxAmount != null && row.taxAmount !== ''" style="color:#E6A23C">税额 ¥{{ formatMoney(row.taxAmount) }}</span>
                      <span v-if="row.taxRemark" style="color:#909399;font-size:12px" :title="row.taxRemark">{{ row.taxRemark }}</span>
                    </div>
                  </div>
                  <div class="invAmount">
                    <span>¥{{ formatMoney(row.amount) }}</span>
                    <span class="invOrig">/ ¥{{ formatMoney(row.originalAmount) }}</span>
                  </div>
                  <div class="invOps">
                    <el-button type="text" size="mini" @click="invoicePreview(row)">预览</el-button>
                  </div>
                </div>
                <div v-if="allInvoiceList.rows.length == 0" class="invEmpty">暂无发票凭证</div>
              </div>
              <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="allInvoiceList.visible = false">关闭</el-button>
              </span>
            </el-dialog>

            <el-button type="primary" @click="printClick('printBox','')" style="margin:20px 0" v-if="tabName == '财务审核' || type=='batchPrint'">打印/下载</el-button>
            <div id="printBox" class="printBox">
              <div v-for="(item,index) in rei" :key="index" :id="'reiItem' + index" :class="index%2!=0 && index!=0 ? 'reiItem pb' : 'reiItem'">
                <div :id="'checked' + index" style="margin:10px 0" v-if="logData.length>0 && (tabName!='报销单' && type!='dtl')">
                  <el-checkbox v-model="item.checked">勾选打印</el-checkbox>
                </div>
                <div class="reiTop flex">
                  <div class="flex">
                    <div class="qrcode">
                      <img class="cp" :src="imgHead + (item._qrcodeUrl || reiForm.qrcodeUrl)" alt="" v-if="item._qrcodeUrl || reiForm.qrcodeUrl" @click="showQRcode = true">
                      <img v-else src="./../../assets/images/qrcode.png" alt="">
                    </div>
                    <div style="padding-top: 10px;">
                      <div class="reiType">工作日志</div>
                      <div class="reiRnumber">NO:{{item.AdvanceNum}}</div>
                    </div>
                  </div>
                  <div class="centerTitle">
                    <div class="reimbursementTitle">报&nbsp;&nbsp;&nbsp;&nbsp;销&nbsp;&nbsp;&nbsp;&nbsp;单</div>
                    <hr width="130px" color="#000" style="margin-top:-1px;border-color:#000" height="1px">
                    <hr width="130px" color="#000" style="margin-top:-5px;border-color:#000">
                  </div>
                  <div class="flex sb aic reiTopRight">
                    <div class="accountBox">
                      <div class="accountName">付款：{{ item._hdr && item._hdr.companyName ? item._hdr.companyName : item.companyName }}</div>
                      <div class="accountName">收款：{{ item._writtenName || reiForm.writtenName }}</div>
                    </div>
                  </div>
                </div>
                <div class="reiInfo flex sb">
                  <div class="flex">
                    <div>发票抬头：</div>
                    <div class="answer">{{item.companyName}}</div>
                    <!-- <div>部门：</div>
                    <div class="answer">{{writeOffData[0].depName ? writeOffData[0].depName[writeOffData[0].depName.length - 1] : ''}}</div> -->
                  </div>
                  <div class="flex aic reiDate">
                    <div class="answer2">{{moment(item._reimbTime || reiForm.reimbTime).year()}}</div>
                    <div>年</div>
                    <div class="answer2">{{moment(item._reimbTime || reiForm.reimbTime).month() + 1}}</div>
                    <div>月</div>
                  </div>
                </div>
                <table width="99%" border="0" cellspacing="1" cellpadding="4" class="tabtop13" align="center">
                  <tr>
                    <td colspan="2" class="font-center titfont">发生日期</td>
                    <td width="35%" class="font-center titfont" rowspan="2">报销内容</td>
                    <td width="6%" class="font-center titfont" rowspan="2">单据张数</td>
                    <td colspan="9" class="font-center titfont">金额</td>
                    <td class="font-center titfont" rowspan="2">备注</td>
                  </tr>
                  <tr>
                    <td width="5%" class="font-center">月</td>
                    <td width="5%" class="font-center">日</td>
                    <td width="3%" class="font-center">百</td>
                    <td width="3%" class="font-center">十</td>
                    <td width="3%" class="font-center">万</td>
                    <td width="3%" class="font-center">千</td>
                    <td width="3%" class="font-center">百</td>
                    <td width="3%" class="font-center">十</td>
                    <td width="3%" class="font-center">元</td>
                    <td width="3%" class="font-center">角</td>
                    <td width="3%" class="font-center">分</td>
                  </tr>
                  <tr v-for="(row,index) in item.reiData" :key="index">
                    <td class="font-center">{{row.occurDate ? moment(row.occurDate).month() + 1 : ''}}</td>
                    <td class="font-center">{{row.occurDate ? moment(row.occurDate).date() : ''}}</td>
                    <td class="font-center">{{row.reimbursementContent}}</td>
                    <td class="font-center">{{row.documentsNum}}</td>
                    <td class="font-center">{{getNum(row.amounts,'bw')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'sw')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'w')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'q')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'b')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'s')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'g')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'j')}}</td>
                    <td class="font-center">{{getNum(row.amounts,'f')}}</td>
                    <td class="font-center">{{ row.remark }}</td>
                  </tr>
                  <tr>
                    <td colspan="4">合计人民币（大写） {{numberToChinese(item.sum)}}</td>
                    <td class="font-center">{{getNum(item.sum,'bw')}}</td>
                    <td class="font-center">{{getNum(item.sum,'sw')}}</td>
                    <td class="font-center">{{getNum(item.sum,'w')}}</td>
                    <td class="font-center">{{getNum(item.sum,'q')}}</td>
                    <td class="font-center">{{getNum(item.sum,'b')}}</td>
                    <td class="font-center">{{getNum(item.sum,'s')}}</td>
                    <td class="font-center">{{getNum(item.sum,'g')}}</td>
                    <td class="font-center">{{getNum(item.sum,'j')}}</td>
                    <td class="font-center">{{getNum(item.sum,'f')}}</td>
                    <td class="font-center"></td>
                  </tr>
                  <tr>
                    <td colspan="2">主管意见</td>
                    <td colspan="2" class="font-center"></td>
                    <td colspan="9">报销人签章</td>
                    <td class="font-center">{{item._writtenName || reiForm.writtenName}}</td>
                  </tr>
                </table>
                <div class="flex reiBot" style="gap:40px 0">
                  <div class="flex aic" style="margin-right:40px">
                    <span>批准：</span>
                    <span class="reiBotInfo"></span>
                  </div>
                  <div class="flex aic" style="margin-right:40px">
                    <span>复核：</span>
                    <span class="reiBotInfo"></span>
                  </div>
                  <div class="flex aic" style="margin-right:40px">
                    <span>报销人：</span>
                    <span class="reiBotInfo">{{item._writtenName || reiForm.writtenName}}</span>
                  </div>
                  <div class="flex aic" v-if="item.voucherType" style="margin-left:auto">
                    <span>凭证类型：</span>
                    <span class="reiBotInfo">{{ item.voucherType }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <el-form v-if="type!='batchPrint'">
            <el-form-item label="报销金额合计:">
              ￥{{ reiForm.writtenAmount ? reiForm.writtenAmount : '0.00' }}
              <span v-if="Number(reiForm.writtenAmount || 0) !== Number(logAmount || 0) && Number(reiForm.writtenAmount || 0) !== 0 && tabName == '报销单'" style="color:#F56C6C;margin-left:10px;font-weight:600">
                ⚠ 报销金额与日志金额（￥{{ formatMoney(logAmount) }}）不一致！
              </span>
            </el-form-item>
            <el-form-item :label="type=='approve' ? '备注' : '申请报销备注:'">
              <el-input type="textarea" placeholder="请输入内容" v-model="reiForm.applyRemark" :autosize="{ minRows: 2}" style="width:500px" v-if="type!='dtl'">
                <span v-if="type=='dtl'">{{ reiForm.applyRemark }}</span>
              </el-input>
            </el-form-item>

            <div class="Reititle"><span class="titleLine">|</span> 收款帐号</div>
            <el-form :model="reiForm" ref="bankForm" :rules="bankRules" style="padding-left:30px" label-width="110px">
              <el-form-item>
                {{reiForm.writtenName}}
                <!-- <el-input v-model="listQuery.serviceCenterOrCompany" size="small" clearable style="width:180px"></el-input> -->
              </el-form-item>
              <el-form-item label="银行卡开户行:" prop="depositBank">
                <el-input v-model="reiForm.depositBank" size="small" clearable style="width:300px" v-if="type=='add' || type=='edit'"></el-input>
                <span v-else>{{reiForm.depositBank}}</span>
              </el-form-item>
              <el-form-item label="银行卡号:" prop="bankAccount">
                <el-input v-model="reiForm.bankAccount" size="small" clearable style="width:300px" v-if="type=='add' || type=='edit'"></el-input>
                <span v-else>{{reiForm.bankAccount}}</span>
              </el-form-item>
            </el-form>
            <div class="btnBox">
              <el-button @click="goBack">返 回</el-button>
              <el-button type="primary" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="confirmSave('2')" v-if="type=='add' || type=='edit' || type=='approve'" :disabled="isSubmit">{{type=='approve' ? '保存修改' : '仅保存草稿'}}</el-button>
              <el-button type="success" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="confirmSave('3')" v-if="(type=='add' || type=='edit' || type=='approve')&& tabName == '报销单'" :disabled="isSubmit">提交报销</el-button>
              <el-button type="warning" @click="printClick('printBox','')" v-if="(type=='add' || type=='edit' || type=='approve')&& tabName == '报销单' && logData.length>0">打印/下载</el-button>
              <el-button type="danger" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="Approve('0')" v-if="type=='approve'" :disabled="isSubmit">退 回</el-button>
              <!-- <el-button type="success" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="confirmSave('1')" v-if="type=='approve'" :disabled="isSubmit">通 过</el-button> -->
              <el-button type="success" :loading="isBtnLoading" v-preventReClick style="margin-left:10px;" @click="Approve('1')" v-if="type=='approve'" :disabled="isSubmit">通 过</el-button>
            </div>
          </el-form>

        </div>
        <div v-if="activeName3=='1' && this.WorkerList.length>0">
          <div style="margin-left:30px">
            <el-steps direction="vertical" :active="WorkerList.length - 1" finish-status="success">
              <el-step v-for="(item,index) in WorkerList" :key="index" :title="item.nodeName" :description="item.title"></el-step>
            </el-steps>
          </div>
        </div>

        <div class="timelineBox" v-if="activeName3=='2'">
          <el-timeline>
            <el-timeline-item placement="top" v-for="(item,index) in WorkerList" :key="index">
              <el-card>
                <p>时间：{{ item.createTime ? item.createTime.replace('T',' ')  :''}}</p>
                <p>记录：{{ item.title }} <span v-if="item.remark" style="margin-left: 20px;">备注： {{ item.remark }}</span> </p>
                <p>处理人：{{ item.userName }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>

    </div>
    <div v-else v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"></div>
    <el-dialog title="添加发票号码" :visible.sync="showAddInvoiceNum" width="500px">
      <el-form ref="prForm" label-width="80px">
        <el-form-item label="发票号码" v-for="(item,index) in invoiceNumList" :key="index">
          <el-input v-model="item.num" style="width:220px" size="small" @blur="judgeRepeat2(item.num,index)"></el-input>
          <el-button type="text" style="margin-left:10px" @click="delInvoiceNum(index)" v-if="invoiceNumList.length>1">删除</el-button>
        </el-form-item>
        <el-button type="text" @click="addNewInvoiceNum">添加发票号码</el-button>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddInvoiceNum = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddInvoiceNum" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="showQRcode" width="480px">
      <img :src="imgHead + reiForm.qrcodeUrl" alt="" style="width: 300px;height: 300px;margin-left: 50px;">
      <span slot="footer" class="dialog-footer">
        <el-button @click="showQRcode = false" size="small">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import print from 'print-js';
  import pdfViewer from 'vue-pdf'; //PDF凭证渲染成图片后一起打印
  import * as math from 'mathjs'
  import moment from 'moment';
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    printReiAdaptive
  } from '@/utils/reiPrint'; //自适应页型打印：A5 为主，超高块 A4

  // ---------------------------------------------------------------------------
  // PDF 表格线框修补
  // 背景：某些电子发票生成器（iText 模板）把表格网格的路径构造指令（re/m/l）攒在内容流里
  // 不立即描边，直到流末尾才统一 S 描边，中间隔着大量 BT/ET 文本块和 q/Q 状态对。
  // PDF 规范下这合法（路径跨文本块持续累积，最后一次 S 全部绘制），Chrome/Adobe 原生渲染
  // 正常；但 pdf.js 的画布后端跨文本块会丢失累积路径，导致该类发票打印/渲染时表格线框消失。
  // 处理：把"已构造但未描边"的路径，在其后第一个会破坏/改变描边上下文的算符前提前注入 S
  // （此时线宽/颜色与生成器构造路径时一致，与原最终描边意图等价）。修补后的内容流以未压缩
  // 方式写回（去 /Filter、直写 /Length），并重建经典 xref 表。
  // 范围：仅处理无加密、无对象流的经典 PDF，且只改动同时满足下面多个条件的页面内容流；
  // 普通 PDF / 字体 / CMap / 图片一律原样返回，零副作用。
  // ---------------------------------------------------------------------------
  //pdf.js 解析 CID 字体发票必需的 CMap 资源目录（部署于 public/cmaps）
  //缺失时 CID 无法映射到字符，发票可变文字（发票号/明细/金额等）整段丢失，仅剩线框图章
  var PDF_CMAP_URL = (process.env.BASE_URL || './') + 'cmaps/';

  function patchPdfGridLines(bytes) {
    if (!bytes || bytes.length < 8 || typeof DecompressionStream === 'undefined') {
      return Promise.resolve(bytes);
    }
    var bin = toLatin1(bytes);
    if (bin.indexOf('%PDF') !== 0 || bin.indexOf('/ObjStm') >= 0 || bin.indexOf('/Encrypt') >= 0) {
      return Promise.resolve(bytes);
    }
    if (bin.lastIndexOf('trailer') < 0) {
      return Promise.resolve(bytes); // xref stream 类 PDF（无 trailer 关键字）不处理
    }

    // ---------- 基础工具 ----------
    function toLatin1(u8) {
      var s = '';
      for (var i = 0; i < u8.length; i += 8192) {
        s += String.fromCharCode.apply(null, u8.subarray(i, Math.min(i + 8192, u8.length)));
      }
      return s;
    }

    function fromLatin1(s) {
      var u8 = new Uint8Array(s.length);
      for (var i = 0; i < s.length; i++) u8[i] = s.charCodeAt(i) & 0xff;
      return u8;
    }

    function pdfInflate(u8) {
      var ds = new DecompressionStream('deflate'); // FlateDecode = zlib 格式
      return new Response(new Blob([u8]).stream().pipeThrough(ds)).arrayBuffer()
        .then(function (ab) {
          return new Uint8Array(ab);
        });
    }

    // ---------- 内容流分词（保留原文位置） ----------
    function tokenizeContent(s) {
      var toks = [],
        n = s.length,
        i = 0;

      function isWs(c) {
        return c === ' ' || c === '\t' || c === '\r' || c === '\n' || c === '\f' || c === '\0';
      }

      function isDelim(c) {
        return isWs(c) || c === '/' || c === '[' || c === ']' || c === '<' || c === '(' || c === ')';
      }
      while (i < n) {
        var c = s[i];
        if (isWs(c)) {
          i++;
          continue;
        }
        var start = i;
        if (c === '%') { // 注释跳到行尾
          while (i < n && s[i] !== '\n' && s[i] !== '\r') i++;
          continue;
        }
        if (c === '(') { // 字面字符串（处理转义与嵌套）
          var depth = 1;
          i++;
          while (i < n && depth) {
            if (s[i] === '\\') {
              i += 2;
              continue;
            }
            if (s[i] === '(') depth++;
            else if (s[i] === ')') depth--;
            i++;
          }
          toks.push({
            kind: 'val',
            start: start,
            end: i
          });
          continue;
        }
        if (c === '<') {
          if (s[i + 1] === '<') {
            toks.push({
              kind: 'op',
              value: '<<',
              start: start,
              end: i + 2
            });
            i += 2;
            continue;
          }
          var j = s.indexOf('>', i);
          i = j < 0 ? n : j + 1;
          toks.push({
            kind: 'val',
            start: start,
            end: i
          });
          continue;
        }
        if (c === '[') { // 数组（内部可能含字符串）
          i++;
          while (i < n && s[i] !== ']') {
            if (s[i] === '\\') {
              i += 2;
              continue;
            }
            if (s[i] === '(') {
              var d2 = 1;
              i++;
              while (i < n && d2) {
                if (s[i] === '\\') {
                  i += 2;
                  continue;
                }
                if (s[i] === '(') d2++;
                else if (s[i] === ')') d2--;
                i++;
              }
              continue;
            }
            i++;
          }
          i++;
          toks.push({
            kind: 'val',
            start: start,
            end: i
          });
          continue;
        }
        if (c === ')') {
          toks.push({
            kind: 'val',
            start: start,
            end: i + 1
          });
          i++;
          continue;
        }
        if (c === '/') { // 名称
          i++;
          while (i < n && !isDelim(s[i])) i++;
          toks.push({
            kind: 'val',
            start: start,
            end: i
          });
          continue;
        }
        var k = i;
        while (k < n && !isDelim(s[k])) k++;
        var w = s.slice(i, k);
        if (/^[-+.]?[\d.]+$/.test(w)) toks.push({
          kind: 'num',
          start: i,
          end: k
        });
        else toks.push({
          kind: 'op',
          value: w,
          start: i,
          end: k
        });
        i = k;
      }
      return toks;
    }

    // 路径构造后未描边时，遇到下列算符前提前注入 S（描边状态在注入点与构造点一致）
    var TRIGGERS = {
      BT: 1,
      q: 1,
      Q: 1,
      Do: 1,
      cm: 1,
      d: 1,
      w: 1,
      RG: 1,
      G: 1,
      gs: 1,
      BI: 1,
      sh: 1
    };
    var PATH_OPS = {
      re: 1,
      m: 1,
      l: 1,
      c: 1,
      v: 1,
      y: 1,
      h: 1
    };
    var PAINT_OPS = {
      S: 1,
      s: 1,
      f: 1,
      F: 1,
      B: 1,
      b: 1,
      n: 1
    };

    function injectStrokeOps(s) {
      var toks = tokenizeContent(s);
      var pending = false,
        inj = 0,
        skipInline = false;
      var buf = '',
        pos = 0;
      for (var i = 0; i < toks.length; i++) {
        var tk = toks[i];
        if (tk.kind !== 'op') continue;
        var v = tk.value;
        if (v === 'BI') skipInline = true;
        if (v === 'EI') skipInline = false;
        if (!skipInline && pending && TRIGGERS[v]) {
          buf += s.slice(pos, tk.start) + 'S\n';
          pos = tk.start;
          inj++;
          pending = false;
        }
        if (PAINT_OPS[v]) pending = false;
        if (PATH_OPS[v]) pending = true;
      }
      if (!inj) return s;
      buf += s.slice(pos);
      return buf;
    }

    // 去掉 /Filter 与 /DecodeParms，直写新 /Length（未压缩存储）
    function rewriteStreamDict(dict, newLen) {
      var d = dict;
      d = d.replace(/\/Filter\s*(\[[^\]]*\]|\/[A-Za-z0-9]+)/, '');
      d = d.replace(/\/DecodeParms\s*(\[[^\]]*\]|<<[\s\S]*?>>|\/[A-Za-z0-9]+)/, '');
      d = d.replace(/\/Length\s+\d+/, '/Length ' + newLen);
      return d;
    }

    // ---------- 1. 扫描对象头与流区域 ----------
    // 流字典取"最近的前置对象头"到 stream 关键字之间的文本。
    // 不用从 stream 回溯找 << 的传统做法：签名字典（/Contents 大占位符 + 含二进制的括号字符串）
    // 会破坏括号配对，导致字典定位失败。
    var hdrs = [];
    var reHdr = /(\d+)\s+(\d+)\s+obj\b/g,
      hm;
    while ((hm = reHdr.exec(bin))) {
      hdrs.push({
        num: parseInt(hm[1], 10),
        at: hm.index,
        end: hm.index + hm[0].length
      });
    }
    var regions = [];
    var reStream = /stream\r?\n/g,
      m, hIdx = 0;
    while ((m = reStream.exec(bin))) {
      if (m.index >= 3 && bin.substr(m.index - 3, 3) === 'end') continue; // 跳过 endstream 内的伪 stream
      while (hIdx < hdrs.length && hdrs[hIdx].end <= m.index) hIdx++;
      var owner = hIdx > 0 ? hdrs[hIdx - 1] : null; // 最近的前置对象头即所属对象
      var dict = owner ? bin.slice(owner.end, m.index) : '';
      var ok = /^\s*<</.test(dict);
      var lm = ok ? /\/Length\s+(\d+)\s*(?=[\/>\s])/.exec(dict) : null;
      var isFlate = ok ? /\/Filter\s*(?:\[\s*\/FlateDecode\s*\]|\/FlateDecode\b)/.test(dict) : false;
      var payloadStart = m.index + m[0].length;
      var payloadEnd;
      if (lm) {
        payloadEnd = payloadStart + parseInt(lm[1], 10);
        if (payloadEnd + 9 > bin.length || bin.indexOf('endstream', payloadEnd) < 0) continue;
      } else {
        // 间接 /Length：不修补，但为对象头扫描排除载荷区
        var esF = bin.indexOf('endstream', payloadStart);
        if (esF < 0) continue;
        payloadEnd = esF;
      }
      regions.push({
        dictStart: owner ? owner.end : 0,
        dictEnd: m.index,
        payloadStart: payloadStart,
        payloadEnd: payloadEnd,
        isFlate: isFlate,
        patchable: !!(lm && isFlate)
      });
      reStream.lastIndex = payloadEnd; // 跳过二进制载荷，避免载荷内伪 stream
    }

    function inPayload(pos) {
      for (var i = 0; i < regions.length; i++) {
        var r = regions[i];
        if (pos >= r.payloadStart - 4 && pos < r.payloadEnd + 12) return true;
      }
      return false;
    }
    var objects = []; // {num, at} 排除流载荷区后的真实对象头
    for (var i2 = 0; i2 < hdrs.length; i2++) {
      if (!inPayload(hdrs[i2].at)) objects.push({
        num: hdrs[i2].num,
        at: hdrs[i2].at
      });
    }

    // ---------- 2. 解压并修补各内容流 ----------
    var jobs = [];
    for (var i = 0; i < regions.length; i++) {
      (function (r) {
        if (!r.patchable) return;
        jobs.push(
          pdfInflate(bytes.subarray(r.payloadStart, r.payloadEnd))
          .then(function (decompressed) {
            // 内容流几乎全为可打印 ASCII；字体/图像等二进制流即使偶然命中路径模式
            // 也绝不能改动（注入 S 会破坏字体），非 ASCII 占比过高一律跳过
            var printable = 0;
            for (var k = 0; k < decompressed.length; k++) {
              var b = decompressed[k];
              if ((b >= 32 && b < 127) || b === 9 || b === 10 || b === 13 || b === 12) printable++;
            }
            if (printable < decompressed.length * 0.85) return null;
            var t = toLatin1(decompressed);
            // 排除非页面内容流：ToUnicode CMap / Type1 字体（clear-text 部分）等
            if (t.indexOf('begincmap') >= 0 || t.indexOf('eexec') >= 0 || t.indexOf('/FontType') >= 0) return null;
            // 页面内容流必然同时含 BT/ET 文本块
            if (!/\bBT\b/.test(t) || !/\bET\b/.test(t)) return null;
            var patched = injectStrokeOps(t);
            if (patched === t) return null;
            return {
              region: r,
              text: patched
            };
          })
          .catch(function () {
            return null;
          })
        );
      })(regions[i]);
    }
    return Promise.all(jobs).then(function (results) {
      var patches = results.filter(function (x) {
        return x;
      });
      if (!patches.length) return bytes; // 无需修补：原样返回

      // ---------- 3. 分段拼接输出，映射对象偏移 ----------
      patches.sort(function (a, b) {
        return a.region.dictStart - b.region.dictStart;
      });
      var out = '',
        cursor = 0,
        shift = 0;
      var newOffsets = {};
      var objIdx = 0;

      function emitChunk(endPos) {
        if (endPos <= cursor) return;
        var seg = bin.slice(cursor, endPos);
        out += seg;
        // 该区间内对象头偏移 = 原偏移 + 当前累积位移
        while (objIdx < objects.length && objects[objIdx].at < endPos) {
          newOffsets[objects[objIdx].num] = objects[objIdx].at + shift;
          objIdx++;
        }
        cursor = endPos;
      }
      for (var p = 0; p < patches.length; p++) {
        var r = patches[p].region;
        emitChunk(r.dictStart);
        var newDict = rewriteStreamDict(bin.slice(r.dictStart, r.dictEnd), patches[p].text.length);
        var es2 = bin.indexOf('endstream', r.payloadEnd);
        var beforeLen = out.length;
        out += newDict + '\nstream\n' + patches[p].text + '\n';
        shift += (out.length - beforeLen) - (es2 - r.dictStart);
        cursor = es2;
      }
      // 原文件尾部的 xref/trailer/startxref 由下面重建，拼接时须截断掉
      var trP = bin.lastIndexOf('trailer');
      var tailStart = bin.length;
      if (trP >= 0) {
        var xr = bin.lastIndexOf('\nxref', trP);
        if (xr > 0 && /^xref\s*\n\d+\s+\d+\n/.test(bin.slice(xr + 1, xr + 40))) tailStart = xr + 1;
      }
      emitChunk(tailStart);

      // ---------- 4. 重建 xref 表与 trailer ----------
      var maxNum = 0;
      for (var num in newOffsets)
        if (+num > maxNum) maxNum = +num;
      var trPos = bin.lastIndexOf('trailer');
      var trDict = '';
      if (trPos >= 0) {
        var sx = bin.indexOf('startxref', trPos);
        trDict = bin.slice(trPos + 7, sx > 0 ? sx : bin.length);
        trDict = trDict.replace(/\/Prev\s+\d+/, '').replace(/\/XRefStm\s+\d+/, '');
      }
      var xref = 'xref\n0 ' + (maxNum + 1) + '\n';
      xref += '0000000000 65535 f \n';
      for (var n2 = 1; n2 <= maxNum; n2++) {
        xref += (newOffsets[n2] !== undefined ?
          ('0000000000' + newOffsets[n2]).slice(-10) + ' 00000 n \n' :
          '0000000000 65535 f \n');
      }
      var tail = 'trailer\n' + trDict + 'startxref\n' + out.length + '\n%%EOF\n';
      return fromLatin1(out + xref + tail);
    });
  }

  export default {
    data() {
      return {
        listQuery: {
          PageModel: {
            Rows: 10000,
            Page: 1,
            OrderInput: [{
              property: "applyTime",
              order: 0
            }]
          },
          applyMonth: '',
          userId: Cookies.get("userid-b"),
          applyUserNameId: '',
          roleType: localStorage.loginRoletype,
        },
        showQRcode: false,
        writeOffData: [{
          companyName: '', //公司名称（发票抬头）
          depName: "", //部门名
          AdvanceNum: '', //编号
          voucherType: '电子', //凭证类型：电子凭证/纸质凭证
          reimbUserName: '', //报销人
          collapsed: false,
          reiData: [{
            occurDate: '', //发生日期
            reimbursementContent: '', //报销内容
            documentsNum: '', //单据张数
            invoiceNum: '', //发票号码
            amounts: '', //金额
            remark: '', //备注
            invoiceType: '', //发票类型（OCR 识别返回，可编辑）
            projectName: '', //项目名称（OCR 识别返回，可编辑）
            invoices: [], //发票凭证明细
          }]
        }],
        imgHead: this.$store.state.EMP.imgPath,
        written: {
          username: localStorage.userName,
          userid: Cookies.get("userid-b")
        },
        logAmount: '', //日志金额合计
        id: '',
        writeOffId: null, //核销id
        reiForm: {
          id: '',
          writtenName: '', //核销提交人
          WrittenId: '', //核销提交人id
          companyName: "", //公司名
          depName: "", //部门名
          reimbTime: moment().format('YYYY-MM-DD'), //报销日期
          applyRemark: "", //申请报销备注
          writtenAmount: "", //报销金额合计
          advanceIds: "", //暂支ID
          bankAccount: '', //银行卡号
          depositBank: '', //银行卡开户行
          reimbContent: [], //报销内容
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        depName: '', //部门名称
        logData: [],
        fileList: [],
        rei: [{
          companyName: '', //公司名称
          depName: "", //部门名
          AdvanceNum: '', //编号
          reiData: [{
            occurDate: '', //发生日期
            reimbursementContent: '', //报销内容
            invoiceNum: '', //发票号码
            documentsNum: '', //单据张数
            amounts: '', //金额
            remark: '', //备注
          }]
        }],
        teContList: [], //报销内容列表
        baseInfo: {},
        showDropScreen: -1,
        headPath: this.$store.state.EMP.tablePath,
        roletype: localStorage.loginRoletype,
        totalcount: 0,
        loading: false,
        type: '',
        timeStart: '',
        timeEnd: '',
        isBtnLoading: false,
        isBtnLoading2: false,
        activeName3: '0',
        WorkerList: [], //工作流
        OAdata: [],
        OAinfo: {},
        customerList: [], //客服列表
        departmentList: [], //部门列表
        legList: [], //公司列表
        companyName: '',
        props: {
          label: 'strorganname',
          value: 'strorganname',
          children: 'children',
          checkStrictly: true
        },
        activeName: '',
        tabName: '',
        delData: [], //没有权限的单子 暂时存这
        isSubmit: false,
        resId: '',
        showAddInvoiceNum: false,
        invoiceNumList: [{
          num: ''
        }],
        writeOffIds: [], //批量打印：多个核销id
        autoPrint: false, //批量打印场景下由列表页传入，详情加载完成后自动触发打印
        showInvoiceImport: false, //导入发票凭证弹窗
        ocrFileList: [], //待识别的发票文件
        ocrLoading: false,
        ocrEngine: 'deepseek', //识别引擎：baidu=百度票据识别，deepseek=DeepSeek大模型
        failPrintFiles: [], //打印时未能并入的PDF凭证（标题下方红字提示）
        ocrPreview: {
          visible: false,
          validList: [],
          invalidList: [],
          selection: [],
          autoSplit: true,
        },
        invoiceList: {
          visible: false,
          pageIndex: 0,
          rowIndex: 0,
          rows: [],
        },
        allInvoiceList: {
          visible: false,
          rows: [], //财务审核：全部报销单的发票凭证汇总
        },
        info: {},
        rule: {
          companyName: {
            required: true,
            message: '请选择发票抬头',
            trigger: 'blur'
          },
        },
        bankRules: {
          'depositBank': {
            required: true,
            message: '请输入银行卡开户行',
            trigger: 'blur'
          },
          'bankAccount': {
            required: true,
            message: '银行卡号',
            trigger: 'blur'
          },
        }
      }
    },
    created() {
      if (this.$route.query.autoPrint != undefined && this.$route.query.autoPrint == 1) {
        this.autoPrint = true;
      }
      if (this.$route.query.type != undefined && this.$route.query.type) {
        this.type = this.$route.query.type;
        this.activeName = this.$route.query.activeName;
        this.tabName = this.$route.query.tabName;
        if (this.type == 'edit' || this.type == 'dtl' || this.type == 'approve') {
          if (this.tabName == '财务审核' || this.tabName == '待打款') {
            this.companyName = this.$route.query.companyName;
            this.writeOffId = this.$route.query.advanceId;
            this.id = this.$route.query.id;
            // this.GetJbBusiaAdvLogWritFinans();
            this.writeOffId = this.$route.query.id
            this.GetWriteoffDetail();
          } else {
            this.writeOffId = this.$route.query.id;
            this.id = this.$route.query.id;
            this.GetWriteoffDetail();
          }
        }

        if (this.type == 'batchPrint' && this.$route.query.writeOffIds) {
          //批量打印：多个核销id合并到同一页面打印
          this.writeOffIds = this.$route.query.writeOffIds.split(',');
          this.GetWriteoffDetailBatch();
        }

        if (this.type == 'approve') {
          this.GetApprovalList();
        }
      }
      this.getTeContList();
      this.getMemberList();
      this.getDepartList();
      this.getlegalsubjectlist();
      if (this.type == 'add') {
        this.aaa();
      }
      let now = moment().format('YYYY-MM-DD');
      if (moment(now).date() > 15) {
        this.listQuery.applyMonth = moment().format('YYYY-MM')
      } else {
        this.listQuery.applyMonth = moment(now).subtract(1, 'months').format('YYYY-MM');
        this.reiForm.reimbTime = moment(now).subtract(1, 'months').format('YYYY-MM-DD');
      }
    },
    computed: {
      //报销单是否可编辑
      reiEditable() {
        return (this.type == 'add' || this.type == 'edit' || this.type == 'approve') && !this.isSubmit
      },
      //当前打印编号的完整内容（批量打印时以各报销单自身编号为准）
      printNo() {
        if (this.reiForm.oanum) return this.reiForm.oanum
        let nos = [...new Set((this.writeOffData || []).map(item => item.AdvanceNum).filter(n => n))]
        return nos.join('、')
      },
      //当前打印编号的显示文本：单张时按长度截断，多张时显示第一个、第二个和最后一个编号
      printNoText() {
        let nos = [...new Set((this.writeOffData || []).map(item => item.AdvanceNum).filter(n => n))]
        if (!this.reiForm.oanum && nos.length > 1) {
          if (nos.length == 2) return nos[0] + '、' + nos[1]
          if (nos.length == 3) return nos[0] + '、' + nos[1] + '、' + nos[2]
          return nos[0] + '、' + nos[1] + '...' + nos[nos.length - 1]
        }
        return this.shortPrintNo(this.printNo)
      },
      //总行数
      rowCount() {
        let n = 0;
        this.writeOffData.forEach(item => {
          n += (item.reiData || []).length
        })
        return n
      },
      //发票总张数
      invoiceCount() {
        let n = 0;
        this.writeOffData.forEach(item => {
          item.reiData.forEach(row => {
            n += this.rowInvoiceCount(row)
          })
        })
        return n
      },
      //报销金额合计
      reiTotal() {
        let sum = 0;
        this.writeOffData.forEach(item => {
          item.reiData.forEach(row => {
            sum += Number(row.amounts) || 0
          })
        })
        return sum.toFixed(2)
      },
      //OCR 识别结果汇总：各科目小计、报销总金额、税额总金额（勾选优先，否则全部有效票）
      ocrSummary() {
        let sel = this.ocrPreview.selection || []
        let list = sel.length > 0 ? sel : (this.ocrPreview.validList || [])
        let byCost = {}
        let amount = 0,
          tax = 0
        list.forEach(e => {
          let a = Number(e.amount != null && e.amount !== '' ? e.amount : e.originalAmount) || 0
          let t = Number(e.taxAmount) || 0
          amount += a;
          tax += t
          let k = (e.costName && e.costName != '待定') ? e.costName : '待定'
          if (!byCost[k]) byCost[k] = {
            amount: 0,
            tax: 0
          }
          byCost[k].amount += a;
          byCost[k].tax += t
        })
        return {
          count: list.length,
          amount: amount,
          tax: tax,
          byCost: byCost,
          fromSelection: sel.length > 0
        }
      },
    },
    methods: {
      checkPermission,
      down(url, name) {
        console.log(url, name)
        var path = url;
        const aTag = document.createElement('a')
        aTag.download = name //这里写保存时的名称
        aTag.href = path
        aTag.click();
      },
      aaa() {
        setTimeout(() => {
          this.changeUser(this.written)
        }, 100);
      },
      //获取报销内容
      getTeContList() {
        let data = {
          parentId: 1
        }
        xz.AdvanceFun(data, 'GetDicList').then(res => {
          if (res.status == 'ok') {
            this.teContList = res.data
          } else {
            this.teContList = [];
          }
        })
      },
      // 获取业务部门列表
      getDepartList() {
        xz.getorganstr('', '', {
          strIsDisable: '1'
        }).then(res => {
          if (res.status == 'ok') {
            this.departmentList = res.msg.parent[0].children
          } else {
            this.departmentList = []
          }
        })
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let d = {
          userid: Cookies.get("userid-b"),
          companyName: '',
          isCanInsure: false,
          pageNum: 1,
          pageSize: 1000
        }
        xz.ArdCurStat(d, 'GetUserLegalList').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data.date;
          } else {
            this.legList = [];
          }
        })

      },
      // 获取权限内客服列表
      getMemberList() {
        xz.GetAllLowUser(Cookies.get("userid-b")).then(res => {
          if (res.status == 'ok') {
            this.customerList = res.data;
          } else {
            this.customerList = [];
          }
        })
      },
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN" ||
          o == '[{}]'
        );
      },
      //打印
      //编号过长时只显示首尾字符，鼠标悬浮（title）显示完整编号
      shortPrintNo(val) {
        if (!val) return '';
        if (val.length <= 10) return val;
        return val.charAt(0) + '...' + val.charAt(val.length - 1);
      },
      printClick(id, ignoreIds) {
        if (this.isSubmit || this.tabName != '报销单' || this.type == 'batchPrint') {
          let arr = [];
          this.rei.forEach((element, index) => {
            let d = 'checked' + index;
            arr.push(d)
            //只有用户明确取消勾选（checked===false）才排除整页，避免未初始化勾选状态的页被误排除
            if (element.checked === false) {
              let dd = 'reiItem' + index;
              arr.push(dd)
            }
          });
          const style = '.page {margin:0 10mm};' //打印时去掉眉页眉尾
          // 先清掉上一次打印残留的临时发票节点，避免重复打印时图片叠加
          this.removePrintInvoiceImgs();
          // 把每张报销单对应的发票凭证，打印在该报销单（reiItem）下方
          // 图片凭证直接以 img 打印；PDF 凭证先用 pdfjs 逐页渲染成图片再加入，避免 PDF 当作图片打印导致失败
          let pdfTasks = [];
          let failFiles = []; //未能渲染成图片的PDF凭证
          let pendingImgs = []; //所有临时加入的发票图片，打印前必须等它们全部加载完成
          //打印准备全程遮罩：从 PDF 转图开始，直到打印弹窗弹出才关闭
          let printMask = this.$loading({
            fullscreen: true,
            text: '正在准备打印，请稍候…',
            background: 'rgba(255,255,255,.8)'
          });
          if (this.writeOffData && this.writeOffData.length) {
            this.writeOffData.forEach((page, pageIndex) => {
              let pageBox = document.getElementById('reiItem' + pageIndex);
              if (!pageBox) return;
              let fileMap = new Map();
              (page.reiData || []).forEach(row => {
                (row.invoices || []).forEach(inv => {
                  if (inv.fileUrl) fileMap.set(inv.fileUrl, {
                    url: inv.fileUrl,
                    name: inv.fileName || ''
                  });
                });
              });
              let files = [...fileMap.values()]; //按文件地址去重
              if (!files.length) return;
              let invoiceImgsWrap = document.createElement('div');
              invoiceImgsWrap.className = 'printInvoiceImgs';
              invoiceImgsWrap.style.cssText = 'margin-top:10px;';
              pageBox.appendChild(invoiceImgsWrap);
              let addImg = (src) => {
                let img = document.createElement('img');
                img.src = src;
                img.style.cssText = 'max-width:100%;margin-bottom:10px;';
                invoiceImgsWrap.appendChild(img);
                pendingImgs.push(img);
              };
              files.forEach(f => {
                let full = this.filePath2Url(f.url);
                if (/\.pdf/i.test(full) || /\.pdf/i.test(f.name)) {
                  //PDF凭证：渲染成图片再打印；渲染失败只提示，不新开页签打断整批打印
                  pdfTasks.push(this.pdfToImgList(full).then(imgs => {
                    if (imgs.length) {
                      imgs.forEach(addImg);
                    } else {
                      failFiles.push(f.name || full);
                    }
                  }));
                } else {
                  addImg(full);
                }
              });
            });
          }
          //等 PDF 渲染完成后再触发打印，保证 PDF 凭证能一起打印出来
          Promise.all(pdfTasks).then(() => {
            //关键修复：printJS 的 targetStyles:['*'] 会把克隆瞬间每个元素的计算样式（含宽高）冻结成内联样式。
            //如果发票图片还没加载完就去打印，图片容器高度会被冻结成 0，而图片在打印 iframe 里加载完后
            //又按原始尺寸渲染，溢出容器与下一张报销单叠在一起（重叠 bug 的根源）。
            //所以必须等所有发票图片真正加载完成（或失败/超时兜底）后再触发打印。
            return Promise.all(pendingImgs.map(img => new Promise(resolve => {
              if (img.complete) return resolve(); //已加载或已失败都不阻塞
              let done = false;
              let finish = () => {
                if (!done) {
                  done = true;
                  resolve();
                }
              };
              img.addEventListener('load', finish);
              img.addEventListener('error', finish);
              setTimeout(finish, 15000); //兜底：网络极慢时也照常打印，避免卡死
            })));
          }).then(() => {
            this.failPrintFiles = failFiles; //未并入打印的PDF凭证：页面标题下方红字提示
            setTimeout(() => {
              //自适应页型打印：A5 横向为主，明细超高的报销单块自动改用 A4 纵向，单次任务混合页型输出
              printReiAdaptive(document.getElementById(id), {
                ignoreIds: arr, //不打印的元素：勾选框（所有页）与未勾选页整体
                onReady: () => {
                  printMask.close();
                }, //打印弹窗弹出，关闭遮罩
                onError: () => {
                  printMask.close();
                },
                onAfterPrint: () => {
                  // 打印结束移除临时发票图片节点（每张报销单下方一个）
                  this.removePrintInvoiceImgs();
                }
              });
            }, 500)
          }).catch(() => {
            printMask.close();
            this.$message.error('发票凭证打印准备失败，请重试或逐张打印');
          })
        } else {
          this.$message.warning('提交后才能打印')
        }
        //各个配置项
        //printable:要打印的id。
        //type:可以是 html 、pdf、 json 等。
        //properties:是打印json时所需要的数据属性。
        //gridHeaderStyle和gridStyle都是打印json时可选的样式。
        //repeatTableHeader:在打印JSON数据时使用。设置为时false，数据表标题将仅在第一页显示。
        //scanStyles:设置为false时，库将不处理应用于正在打印的html的样式。使用css参数时很有用，此时自己设置的原来想要打印的样式就会失效，在打印预览时可以看到效果
        //targetStyles: [’*’],这样设置继承了页面要打印元素原有的css属性。
        //style:传入自定义样式的字符串，使用在要打印的html页面 也就是纸上的样子。
        //ignoreElements：传入要打印的div中的子元素id，使其不打印。非常好用
      },
      //移除打印时临时插入的发票图片节点
      removePrintInvoiceImgs() {
        let ws = document.querySelectorAll('.printInvoiceImgs');
        for (let i = 0; i < ws.length; i++) {
          let w = ws[i];
          if (w.parentNode) w.parentNode.removeChild(w);
        }
      },
      GetAdvancesDetail() {
        this.loading = true;
        xz.GetAdvancesDetail(this.listQuery).then(res => {
          try {
            if (res.status == 'ok') {
              this.baseInfo = res.data.adVerifs;
              this.OAdata = res.data.list;
              if (this.OAdata.length > 0 && this.OAdata[0].type != '工作日志') {
                this.OAinfo = this.OAdata[0]
              }
              this.loading = false;
            } else {
              this.OAdata = [];
              this.$message.error(res.msg);
              this.loading = false;
            }
          } catch (e) {
            console.log(e)
            this.$message.error('系统出错');
            this.loading = false;
          }
        })
      },
      //删除行
      delLine(item, index, i) {
        const realIndex = this.writeOffData.indexOf(item)
        const realRowIndex = realIndex < 0 ? index : realIndex
        if (item.reiData.length == 1) {
          //整页只有一行：删掉整页，但不能把所有页都删光
          if (this.writeOffData.length <= 1) {
            this.writeOffData[0].reiData.splice(0, 1, this.newRow())
            return
          }
          this.writeOffData.splice(realRowIndex, 1);
        } else {
          item.reiData.splice(i, 1);
        }
      },
      addLine() {
        let data = {
          occurDate: '', //发生日期
          reimbursementContent: '', //报销内容
          documentsNum: '', //单据张数
          invoiceNum: '', //发票号码
          amounts: '', //金额
          remark: '', //备注
          invoiceType: '', //发票类型（OCR 识别返回，可编辑）
          projectName: '', //项目名称（OCR 识别返回，可编辑）
        }
        if (this.writeOffData[this.writeOffData.length - 1].reiData.length < 6) {
          this.writeOffData[this.writeOffData.length - 1].reiData.push(data);
        } else {
          let d = {
            companyName: '', //公司名称
            depName: "", //部门名
            AdvanceNum: '', //编号
            reiData: [{
              occurDate: '', //发生日期
              reimbursementContent: '', //报销内容
              invoiceNum: '', //发票号码
              documentsNum: '', //单据张数
              amounts: '', //金额
              remark: '', //备注
              invoiceType: '', //发票类型（OCR 识别返回，可编辑）
              projectName: '', //项目名称（OCR 识别返回，可编辑）
            }]
          }
          this.writeOffData.push(d)
        }
      },
      addPage() {
        let d = {
          companyName: this.reiForm.companyName || '', //公司名称（发票抬头）
          depName: "", //部门名
          AdvanceNum: '', //编号
          voucherType: '电子', //凭证类型：电子凭证/纸质凭证
          reimbUserName: this.reiForm.writtenName || '', //报销人
          collapsed: false,
          reiData: [this.newRow()]
        }
        this.writeOffData.push(d)
      },
      //新建一个报销行
      newRow() {
        return {
          occurDate: '', //发生日期
          reimbursementContent: '', //报销内容
          documentsNum: '', //单据张数
          invoiceNum: '', //发票号码（多个用逗号分隔）
          amounts: '', //金额
          remark: '', //备注
          invoiceType: '', //发票类型（OCR 识别返回，可编辑）
          projectName: '', //项目名称（OCR 识别返回，可编辑）
          invoices: [], //发票凭证明细
        }
      },
      //收起/展开报销单
      toggleForm(index) {
        this.$set(this.writeOffData[index], 'collapsed', !this.writeOffData[index].collapsed)
      },
      //删除整个报销单（页）
      delPage(index) {
        this.$confirm('确定删除该报销单吗？', '提示', {
          type: 'warning'
        }).then(() => {
          this.writeOffData.splice(index, 1);
          if (this.writeOffData.length == 0) {
            this.addPage();
          }
          this.complete();
        }).catch(() => {})
      },
      //报销单内新增一行
      addRow(index) {
        if (this.writeOffData[index].reiData.length >= 6) {
          this.$message.warning('每张报销单最多 6 行，请新增一页')
          return
        }
        this.writeOffData[index].reiData.push(this.newRow())
      },
      //行的发票张数
      rowInvoiceCount(row) {
        let n = (row.invoices && row.invoices.length) ? row.invoices.length : 0
        if (n === 0) {
          n = Number(row.documentsNum) || 1
        }
        return n
      },
      //单据张数修改后同步 invoices 长度
      syncDocumentsNum(row) {
        let target = Math.max(1, Number(row.documentsNum) || 1)
        this.$set(row, 'documentsNum', target)
        // invoices 为空时，只保留 documentsNum，让后续导入或手动填写自然生成
        if (!row.invoices || row.invoices.length === 0) return
        if (row.invoices.length > target) {
          row.invoices = row.invoices.slice(0, target)
        } else if (row.invoices.length < target) {
          for (let i = row.invoices.length; i < target; i++) {
            row.invoices.push({
              no: '',
              amount: 0,
              originalAmount: 0,
              seller: '',
              buyer: '',
              date: '',
              costName: '',
              fileUrl: ''
            })
          }
        }
      },
      //行的发票号码展示
      rowInvoiceNos(row) {
        if (!row.invoices || row.invoices.length == 0) {
          return row.invoiceNum || ''
        }
        return row.invoices.map(e => e.no).filter(e => !!e).join(',')
      },
      //手工编辑发票号码后同步回 invoices 数组（保持双向一致）
      syncInvoiceNos(row) {
        let str = (row.invoiceNum || '').trim();
        let nos = str ? str.split(/[,，]/).map(s => s.trim()).filter(Boolean) : [];
        if (row.invoices && row.invoices.length > 0) {
          // invoices 已存在：对齐每张发票的 no 字段，不破坏其他属性
          let inv = row.invoices;
          for (let i = 0; i < Math.max(inv.length, nos.length); i++) {
            if (i < inv.length) {
              this.$set(inv[i], 'no', nos[i] || '');
            } else {
              inv.push({
                no: nos[i],
                amount: 0,
                originalAmount: 0,
                seller: '',
                buyer: '',
                date: '',
                costName: '',
                fileUrl: ''
              });
            }
          }
          // 多余的 invoices 条目（nos 比 inv 少）截断
          if (inv.length > nos.length) {
            row.invoices = inv.slice(0, nos.length);
          }
        } else if (nos.length > 0) {
          this.$set(row, 'invoices', nos.map(no => ({
            no,
            amount: 0,
            originalAmount: 0,
            seller: '',
            buyer: '',
            date: '',
            costName: '',
            fileUrl: ''
          })));
        } else {
          this.$set(row, 'invoices', []);
        }
        this.$set(row, 'documentsNum', (row.invoices && row.invoices.length) || 1);
      },
      //单页发票张数
      pageInvoiceCount(item) {
        let n = 0;
        item.reiData.forEach(row => {
          n += this.rowInvoiceCount(row)
        })
        return n
      },
      //单页金额
      pageAmount(item) {
        let sum = 0;
        item.reiData.forEach(row => {
          sum += Number(row.amounts) || 0
        })
        return sum.toFixed(2)
      },
      //电子凭证三项不合格提示汇总（后端存库时按发票识别内容标记在 subjectFlag/amountFlag/entityNameFlag 上）
      pageWarnings(item) {
        let arr = [];
        if (item.entityNameFlag) arr.push(item.entityNameFlag);
        (item.reiData || []).forEach(row => {
          if (row.subjectFlag) arr.push(row.subjectFlag);
          if (row.amountFlag) arr.push(row.amountFlag);
          //兜底：从发票明细的 notice 收集（OCR 返回时的不合格标记，不依赖 row 级别 flag）
          (row.invoices || []).forEach(inv => {
            if (inv.notice) arr.push(inv.notice);
          });
        })
        return [...new Set(arr)];
      },
      //金额保留两位
      formatMoney(val) {
        let n = Number(val) || 0;
        return n.toFixed(2)
      },
      //报销金额修改后同步本行发票明细的核销金额（发票凭证弹窗里展示/可改的就是这个 amount）
      syncInvoiceAmounts(row) {
        let invs = row.invoices || []
        if (!invs.length) return
        let n = Number(row.amounts)
        if (row.amounts === '' || row.amounts === null || row.amounts === undefined || isNaN(n)) return
        let total = Math.round(n * 100) / 100
        if (invs.length == 1) {
          //单票：全额同步，不超识别金额
          let cap = Number(invs[0].originalAmount) || 0
          let v = Math.min(total, cap)
          invs[0].amount = v
          if (v !== total) {
            this.$set(row, 'amounts', v)
            this.$message.warning('报销金额不能大于发票识别金额，已按识别金额调整')
          }
          return
        }
        //多票：按识别金额占比分摊（无识别金额时均摊），尾差挂最后一票，每票不超过其识别金额
        let origSum = 0
        invs.forEach(e => {
          origSum += Number(e.originalAmount) || 0
        })
        let sum = 0
        let clamped = false
        invs.forEach((e, i) => {
          let cap = Number(e.originalAmount) || 0
          let v
          if (origSum > 0) {
            v = i == invs.length - 1 ? Math.round((total - sum) * 100) / 100 : Math.round(total * cap / origSum * 100) / 100
          } else {
            v = i == invs.length - 1 ? Math.round((total - sum) * 100) / 100 : Math.round(total / invs.length * 100) / 100
          }
          if (v > cap) {
            v = cap;
            clamped = true
          }
          if (v < 0) {
            v = 0;
            clamped = true
          }
          e.amount = v
          sum = Math.round((sum + v) * 100) / 100
        })
        if (sum !== total) {
          this.$set(row, 'amounts', sum)
        }
        if (clamped) {
          this.$message.warning('部分发票报销金额已按其识别金额上限调整')
        }
      },
      //行报销金额失焦校验 + 同步发票明细金额
      checkRowAmount(row) {
        this.complete();
        this.syncInvoiceAmounts(row);
      },
      //==================== 发票凭证导入（OCR识别） ====================
      handleOcrFile(file, fileList) {
        if (file.size > 10 * 1024 * 1024) {
          this.$message.warning('单个文件不能超过10M：' + file.name)
          this.ocrFileList = fileList.filter(f => f.uid != file.uid)
          return
        }
        this.ocrFileList = fileList
      },
      handleOcrFileRemove(file, fileList) {
        this.ocrFileList = fileList
      },
      //上传 → 调用发票识别接口 → 打开识别结果
      startOcr() {
        if (this.ocrFileList.length == 0) {
          this.$message.warning('请先选择发票文件')
          return
        }
        this.ocrLoading = true;
        let upList = this.ocrFileList.map(file => {
          const formData = new FormData();
          formData.append("pagename", "docinf");
          formData.append("action", "save");
          formData.append("userid", Cookies.get("userid-b"));
          formData.append("entid", Cookies.get("userid-b"));
          formData.append("excel", file.raw, file.name);
          return xz.uploadCert(formData).then(url => {
            return {
              name: file.name,
              url: url
            }
          })
        })
        Promise.all(upList).then(list => {
          //识别引擎：baidu=百度票据识别，deepseek=DeepSeek大模型
          let ocrApi = this.ocrEngine == 'deepseek' ? 'InvoiceOcrByDeepSeek' : 'InvoiceOcrByFileUrl';
          //打款公司名：用于后端校验发票购买方
          let payCompany = this.reiForm.companyName || (this.baseInfo && this.baseInfo.remitAgency) || '';
          let ocrList = list.map(item => {
            return xz.AdvanceFun({
              fileUrl: item.url,
              companyName: payCompany,
              verifyParameter: true,
              forceRefresh: false,
            }, ocrApi).then(res => {
              if (res && res.status == 'ok' && res.data) {
                return res.data
              }
              return {
                availableList: [],
                unavailableList: [],
                errMsgList: [(res && res.msg) || '识别失败']
              }
            })
          })
          return Promise.all(ocrList)
        }).then(results => {
          let validList = [];
          let invalidList = [];
          results.forEach(r => {
            (r.availableList || []).forEach(item => {
              let inv = item.invoice || {};
              let amount = inv.amountInFiguersValue !== undefined && inv.amountInFiguersValue !== null ?
                Number(inv.amountInFiguersValue) : 0;
              validList.push({
                id: item.fileHash || item.fileUrl || inv.invoiceNum || Math.random().toString(36).slice(2),
                no: item.invoiceNum || inv.invoiceNum || '',
                date: this.formatInvoiceDate(inv.invoiceDate),
                seller: item.sellerName || (inv.seller && inv.seller.name) || '',
                buyer: (inv.purchaser && inv.purchaser.name) || '',
                originalAmount: amount,
                amount: amount,
                taxAmount: item.taxAmount != null && item.taxAmount !== '' ? Number(item.taxAmount) : (inv.taxAmountValue != null ? Number(inv.taxAmountValue) : null),
                taxRemark: item.taxRemark || '',
                costName: item.costName || '',
                fileUrl: item.fileUrl || '',
                fileName: item.fileName || '',
                fileHash: item.fileHash || '',
                notice: item.message || '', //提示：如"未识别到购买方名称，请人工核对"
                usedMsg: '',
                projectName: inv.projectName || item.projectName || '',
                invoiceType: inv.invoiceType || item.invoiceType || '',
              })
            });
            (r.unavailableList || []).forEach(item => {
              let inv = item.invoice || {};
              let amount = inv.amountInFiguersValue !== undefined && inv.amountInFiguersValue !== null ?
                Number(inv.amountInFiguersValue) : 0;
              invalidList.push({
                no: item.invoiceNum || '',
                date: this.formatInvoiceDate(inv.invoiceDate),
                seller: item.sellerName || (inv.seller && inv.seller.name) || '',
                buyer: (inv.purchaser && inv.purchaser.name) || '',
                originalAmount: amount,
                taxAmount: item.taxAmount != null && item.taxAmount !== '' ? Number(item.taxAmount) : (inv.taxAmountValue != null ? Number(inv.taxAmountValue) : null),
                costName: item.costName || '',
                fileName: item.fileName || '',
                fileUrl: item.fileUrl || '',
                reOcring: false,
                projectName: inv.projectName || item.projectName || '',
                invoiceType: inv.invoiceType || item.invoiceType || '',
                invalidReason: item.message || '识别失败或购买方与打款公司不一致'
              })
            });
            (r.errMsgList || []).forEach(msg => {
              if (msg) {
                //同一文件已在可用/不可用清单中带详情展示时，跳过纯文本错误行，避免重复
                let fn = String(msg).split(/[：:]/)[0].trim();
                let handled = (r.availableList || []).concat(r.unavailableList || []).some(e => e.fileName == fn);
                if (handled) return;
                invalidList.push({
                  no: '',
                  date: '',
                  seller: '',
                  buyer: '',
                  originalAmount: 0,
                  costName: '',
                  fileName: '',
                  invalidReason: msg
                })
              }
            })
          })
          //本次导入内部去重
          let seen = {};
          validList.forEach(e => {
            let key = (e.no || '').toUpperCase();
            if (key) {
              if (seen[key]) {
                e.usedMsg = '本次导入中重复：发票号 ' + e.no
              } else {
                seen[key] = 1
              }
            }
          })
          //已存在于当前报销单的也算重复
          let exists = {};
          this.writeOffData.forEach(item => {
            item.reiData.forEach(row => {
              ((row.invoiceNum || '') + ',' + this.rowInvoiceNos(row)).split(',').forEach(n => {
                if (n && n.trim()) {
                  exists[n.trim().toUpperCase()] = 1
                }
              })
            })
          })
          validList.forEach(e => {
            let key = (e.no || '').toUpperCase();
            if (key && exists[key] && !e.usedMsg) {
              e.usedMsg = '当前报销单中已存在该发票号'
            }
          })
          //创建时校验：调用后端查重，返回被哪个核销单使用
          let checkList = validList.filter(e => !!e.no && !e.usedMsg).map(e => {
            return xz.GetCheckinvoiceNum(this.writeOffId, e.no).then(res => {
              if (!res || res.status != 'ok') {
                e.usedMsg = (res && res.msg) || '该发票号已被使用'
              }
            })
          })
          Promise.all(checkList).then(() => {
            this.ocrLoading = false;
            this.ocrPreview.validList = validList;
            this.ocrPreview.invalidList = invalidList;
            this.ocrPreview.selection = validList.filter(e => !e.usedMsg);
            this.ocrPreview.visible = true;
            this.showInvoiceImport = false;
          })
        }).catch(err => {
          this.ocrLoading = false;
          console.log(err)
          this.$message.error('发票上传识别失败，请重试')
        })
      },
      //识别出来的开票日期统一格式
      formatInvoiceDate(d) {
        if (!d) return ''
        let s = String(d).replace(/[年月]/g, '-').replace(/[日]/g, '')
        let arr = s.split('-')
        if (arr.length >= 3) {
          let y = arr[0],
            m = arr[1].padStart(2, '0'),
            dd = arr[2].padStart(2, '0')
          return y + '-' + m + '-' + dd
        }
        if (s.length == 8) {
          return s.substring(0, 4) + '-' + s.substring(4, 6) + '-' + s.substring(6, 8)
        }
        return String(d)
      },
      validSelChange(val) {
        this.ocrPreview.selection = val
      },
      //单个文件用 DeepSeek 大模型重识别（百度识别不出购销方名称时的兜底）
      reOcrByDeepSeek(row) {
        if (!row.fileUrl) {
          this.$message.warning('该文件没有可用的文件地址，请重新上传')
          return
        }
        this.$set(row, 'reOcring', true)
        let payCompany = this.reiForm.companyName || (this.baseInfo && this.baseInfo.remitAgency) || '';
        xz.AdvanceFun({
          fileUrl: row.fileUrl,
          companyName: payCompany,
          forceRefresh: true,
        }, 'InvoiceOcrByDeepSeek').then(res => {
          this.$set(row, 'reOcring', false)
          if (!res || res.status != 'ok' || !res.data) {
            this.$message.error((res && res.msg) || 'DeepSeek识别失败')
            return
          }
          let available = res.data.availableList || []
          if (available.length == 0) {
            this.$message.error((((res.data.unavailableList || [])[0] || {}).message) || 'DeepSeek也未识别出发票')
            return
          }
          let list = available.map(item => {
            let inv = item.invoice || {};
            let amount = inv.amountInFiguersValue !== undefined && inv.amountInFiguersValue !== null ?
              Number(inv.amountInFiguersValue) : 0;
            return {
              id: item.fileHash || item.fileUrl || inv.invoiceNum || Math.random().toString(36).slice(2),
              no: item.invoiceNum || inv.invoiceNum || '',
              date: this.formatInvoiceDate(inv.invoiceDate),
              seller: item.sellerName || (inv.seller && inv.seller.name) || '',
              buyer: (inv.purchaser && inv.purchaser.name) || '',
              originalAmount: amount,
              amount: amount,
              taxAmount: item.taxAmount != null && item.taxAmount !== '' ? Number(item.taxAmount) : (inv.taxAmountValue != null ? Number(inv.taxAmountValue) : null),
              taxRemark: item.taxRemark || '',
              costName: item.costName || '',
              fileUrl: item.fileUrl || '',
              fileName: item.fileName || '',
              fileHash: item.fileHash || '',
              notice: item.message || '',
              usedMsg: '',
              projectName: item.projectName || inv.projectName || '',
              invoiceType: item.invoiceType || inv.invoiceType || '',
            }
          })
          //与已识别出的有效发票、当前报销单比对
          let exists = {};
          this.ocrPreview.validList.forEach(e => {
            if (e.no) exists[e.no.toUpperCase()] = 1
          })
          this.writeOffData.forEach(item => {
            item.reiData.forEach(r => {
              ((r.invoiceNum || '') + ',' + this.rowInvoiceNos(r)).split(',').forEach(n => {
                if (n && n.trim()) exists[n.trim().toUpperCase()] = 1
              })
            })
          })
          list.forEach(e => {
            let key = (e.no || '').toUpperCase();
            if (key && exists[key]) e.usedMsg = '该发票号已存在'
          })
          //后端查重：是否被其它核销单使用
          let checkList = list.filter(e => !!e.no && !e.usedMsg).map(e => {
            return xz.GetCheckinvoiceNum(this.writeOffId, e.no).then(r2 => {
              if (!r2 || r2.status != 'ok') {
                e.usedMsg = (r2 && r2.msg) || '该发票号已被使用'
              }
            })
          })
          Promise.all(checkList).then(() => {
            this.ocrPreview.validList = this.ocrPreview.validList.concat(list)
            this.ocrPreview.selection = this.ocrPreview.selection.concat(list.filter(e => !e.usedMsg))
            this.ocrPreview.invalidList = this.ocrPreview.invalidList.filter(e => e !== row)
            this.$message.success('DeepSeek识别成功 ' + list.length + ' 张')
          })
        }).catch(() => {
          this.$set(row, 'reOcring', false)
          this.$message.error('DeepSeek识别出错，请重试')
        })
      },
      checkOcrAmount(row) {
        let max = Number(row.originalAmount) || 0;
        if ((Number(row.amount) || 0) > max) {
          this.$message.error('本次核销金额不能大于开票金额')
          this.$set(row, 'amount', max)
        }
      },
      //确认导入到报销单
      confirmImportInvoice() {
        let sel = this.ocrPreview.selection.filter(e => !!e.no)
        if (sel.length == 0) {
          this.$message.warning('请勾选要导入的发票')
          return
        }
        let used = sel.filter(e => !!e.usedMsg)
        if (used.length > 0) {
          this.$message.error('以下发票号已被使用，请先取消勾选：\n' + used.map(e => e.no + '（' + e.usedMsg + '）').join('; '))
          return
        }
        if (this.ocrPreview.autoSplit) {
          //自动按 发票抬头 + 费用科目 拆表：同抬头+同科目的多张发票合并成同一行
          let map = new Map();
          sel.forEach(inv => {
            let entity = inv.buyer || this.reiForm.companyName || ''
            let row = this.buildRowFromInvoice(inv)
            let key = entity + '||' + (row.reimbursementContent || '')
            if (!map.has(key)) {
              map.set(key, [])
            }
            map.get(key).push(row)
          })
          map.forEach((rows, key) => {
            let sep = key.indexOf('||')
            let entity = key.slice(0, sep)
            let subject = key.slice(sep + 2)
            //同组多行合成一行：发票明细拼接、金额合计、备注/主体提示去重汇总
            let row = rows[0]
            let remarks = [row.remark]
            let notices = [row.subjectFlag]
            let types = [row.invoiceType]
            let projects = [row.projectName]
            for (let k = 1; k < rows.length; k++) {
              row.invoices = row.invoices.concat(rows[k].invoices || [])
              //两位小数修正浮点累加误差（如 16.73+16.9=33.629999...）
              row.amounts = Math.round(((Number(row.amounts) || 0) + (Number(rows[k].amounts) || 0)) * 100) / 100
              remarks.push(rows[k].remark)
              notices.push(rows[k].subjectFlag)
              types.push(rows[k].invoiceType)
              projects.push(rows[k].projectName)
            }
            row.remark = remarks.filter(e => !!e).filter((e, i, a) => a.indexOf(e) == i).join('；')
            row.subjectFlag = notices.filter(e => !!e).filter((e, i, a) => a.indexOf(e) == i).join('；')
            //发票类型/项目名称：多票合并时同样去重拼接（同值只保留一份）
            row.invoiceType = types.filter(e => !!e).filter((e, i, a) => a.indexOf(e) == i).join('；')
            row.projectName = projects.filter(e => !!e).filter((e, i, a) => a.indexOf(e) == i).join('；')
            row.documentsNum = row.invoices.length
            row.invoiceNum = row.invoices.map(e => e.no).filter(e => !!e).join(',')
            //给本组汇总 entityNameFlag（取首票 notice 里涉及主体的提示）
            let flag = ''
            let firstInv = row.invoices && row.invoices[0]
            if (firstInv && firstInv.notice && /购买方|抬头|主体/.test(firstInv.notice)) {
              flag = firstInv.notice
            }
            //同一抬头+同一费用科目优先合并进已有报销单（每页最多6行）
            let placed = false
            this.writeOffData.forEach(page => {
              if (placed || (page.companyName || '') !== entity || page.reiData.length == 0 || page.reiData.length >= 6 ||
                !page.reiData.every(r => (r.reimbursementContent || '') === subject)) return
              if (flag && !page.entityNameFlag) {
                this.$set(page, 'entityNameFlag', flag)
              }
              //页内已有同科目行时直接并入该行，保证同抬头+同科目始终只有一行
              let target = null
              for (let k = page.reiData.length - 1; k >= 0; k--) {
                if (page.reiData[k].invoices && page.reiData[k].invoices.length > 0) {
                  target = page.reiData[k]
                  break
                }
              }
              if (target) {
                target.invoices = target.invoices.concat(row.invoices)
                target.amounts = Math.round(((Number(target.amounts) || 0) + (Number(row.amounts) || 0)) * 100) / 100
                if (row.remark) {
                  let rs = (target.remark || '').split('；').concat(row.remark.split('；')).filter(e => !!e)
                  target.remark = rs.filter((e, i, a) => a.indexOf(e) == i).join('；')
                }
                if (row.subjectFlag) {
                  let ns = (target.subjectFlag || '').split('；').concat(row.subjectFlag.split('；')).filter(e => !!e)
                  target.subjectFlag = ns.filter((e, i, a) => a.indexOf(e) == i).join('；')
                }
                //发票类型/项目名称：并入已有行（后端回填的旧行可能没有这两个键，用 $set 保证响应式）
                this.$set(target, 'invoiceType', [target.invoiceType, row.invoiceType].filter(e => !!e).filter((e, i, a) => a.indexOf(e) == i).join('；'))
                this.$set(target, 'projectName', [target.projectName, row.projectName].filter(e => !!e).filter((e, i, a) => a.indexOf(e) == i).join('；'))
                target.documentsNum = target.invoices.length
                target.invoiceNum = target.invoices.map(e => e.no).filter(e => !!e).join(',')
              } else {
                page.reiData.push(row)
              }
              placed = true
            })
            //没有可合并的已有报销单时新建
            if (!placed) {
              this.writeOffData.push({
                voucherType: '电子',
                companyName: entity,
                reimbUserName: this.reiForm.writtenName || '',
                entityName: entity,
                entityNameFlag: flag,
                collapsed: false,
                reiData: [row]
              })
            }
          })
        } else {
          //不拆表：追加到最后一页，满6行自动换页
          sel.forEach(inv => {
            let entity = inv.buyer || this.reiForm.companyName || ''
            let last = this.writeOffData[this.writeOffData.length - 1]
            if (!last || last.reiData.length >= 6) {
              this.addPage()
              last = this.writeOffData[this.writeOffData.length - 1]
              this.$set(last, 'entityName', entity)
            }
            if (!last.companyName) {
              this.$set(last, 'companyName', entity)
            }
            //汇总 entityNameFlag
            if (inv.notice && /购买方|抬头|主体/.test(inv.notice)) {
              this.$set(last, 'entityNameFlag', inv.notice)
            }
            last.reiData.push(this.buildRowFromInvoice(inv))
          })
        }
        //只有一个空页时清掉
        this.clearEmptyPage()
        this.ocrPreview.visible = false;
        this.ocrFileList = [];
        this.complete();
        this.$message.success('已导入 ' + sel.length + ' 张发票凭证')
      },
      //把行内的发票凭证明细同步到结构化字段（发票号码/单据张数），保证保存与打印取到值
      syncRows() {
        if (!this.writeOffData) return
        this.writeOffData.forEach(item => {
          (item.reiData || []).forEach(row => {
            if (row.invoices && row.invoices.length > 0) {
              let nos = row.invoices.map(e => e.no).filter(e => !!e)
              if (nos.length > 0) {
                this.$set(row, 'invoiceNum', nos.join(','))
              }
              this.$set(row, 'documentsNum', row.invoices.length)
            }
          })
        })
      },
      buildRowFromInvoice(inv) {
        let row = this.newRow()
        row.documentsNum = 1
        row.invoiceNum = inv.no
        row.amounts = Number(inv.amount) || 0
        row.invoices = [JSON.parse(JSON.stringify(inv))]
        //OCR 返回的 notice（如"未识别到购买方名称"）同步到 row.subjectFlag
        //这样行级 tooltip 能显示、保存后后端能持久化、重进页面 pageWarnings 也能读到
        if (inv.notice) {
          row.subjectFlag = inv.notice
        }
        //费用科目：用发票消费类型匹配报销内容字典
        row.reimbursementContent = this.matchReimbursementContent(inv)
        row.occurDate = inv.date || ''
        //进项税额备注：写入该发票对应报销行的「备注」
        row.remark = (inv.taxRemark || '').trim() || ((inv.taxAmount != null && inv.taxAmount !== '' && Number(inv.taxAmount) > 0) ? '进项税额' + Number(inv.taxAmount).toFixed(2) + '元' : '')
        //发票类型 / 项目名称：后端 OCR 返回的新字段，行内可编辑
        row.invoiceType = inv.invoiceType || ''
        row.projectName = inv.projectName || ''
        return row
      },
      matchReimbursementContent(inv) {
        if (!this.teContList || this.teContList.length == 0) return ''
        //优先用大模型按费用科目字典归类的结果
        if (inv.costName && inv.costName != '待定') {
          let hit = this.teContList.find(e => e.name == inv.costName)
          if (hit) return hit.name
        }
        let name = this.teContList.find(e => e.name && inv.seller && inv.seller.indexOf(e.name) > -1)
        return name ? name.name : ''
      },
      clearEmptyPage() {
        if (this.writeOffData.length > 1) {
          this.writeOffData = this.writeOffData.filter(item => {
            return item.reiData.some(row => {
              return row.amounts || row.reimbursementContent || (row.invoices && row.invoices.length > 0) || row.invoiceNum
            })
          })
        }
      },
      //自动按 科目 + 主体 重新拆单
      autoSplit() {
        let rows = [];
        this.writeOffData.forEach(item => {
          item.reiData.forEach(row => {
            if (row.amounts || row.reimbursementContent || (row.invoices && row.invoices.length > 0) || row.invoiceNum) {
              rows.push(JSON.parse(JSON.stringify(row)))
            }
          })
        })
        if (rows.length == 0) {
          this.$message.warning('暂无可拆单的报销行')
          return
        }
        let pages = [];
        let map = new Map();
        rows.forEach(row => {
          let subject = row.reimbursementContent || '未指定科目'
          let entity = ''
          if (row.invoices && row.invoices.length > 0 && row.invoices[0].buyer) {
            entity = row.invoices[0].buyer
          }
          let key = subject + '||' + entity
          if (!map.has(key)) {
            map.set(key, [])
          }
          map.get(key).push(row)
        })
        map.forEach((list, key) => {
          let arr = key.split('||')
          for (let i = 0; i < list.length; i += 6) {
            pages.push({
              companyName: arr[1] || '',
              depName: '',
              AdvanceNum: '', //留空让 complete() 为每页生成新编号
              voucherType: '电子',
              reimbUserName: this.reiForm.writtenName || '',
              entityName: arr[1] || '',
              entityNameFlag: '',
              collapsed: false,
              reiData: list.slice(i, i + 6)
            })
          }
        })
        this.writeOffData = pages
        this.complete();
        this.$message.success('已拆成 ' + pages.length + ' 张报销单')
      },
      //==================== 单行的发票凭证列表 ====================
      invoiceCurrentPage() {
        return this.writeOffData[this.invoiceList.pageIndex] || {}
      },
      invoiceCostName() {
        let row = (this.invoiceCurrentPage().reiData || [])[this.invoiceList.rowIndex] || {}
        return row.reimbursementContent || (row.invoices && row.invoices[0] && row.invoices[0].costName) || ''
      },
      invoiceSum(field) {
        let s = 0
        this.invoiceList.rows.forEach(e => {
          s += Number(e[field]) || 0
        })
        return s
      },
      openInvoiceList(pageIndex, rowIndex) {
        let row = this.writeOffData[pageIndex].reiData[rowIndex]
        this.invoiceList.pageIndex = pageIndex
        this.invoiceList.rowIndex = rowIndex
        this.invoiceList.rows = JSON.parse(JSON.stringify(row.invoices || []))
        this.invoiceList.visible = true
      },
      checkInvoiceAmount(row) {
        let max = Number(row.originalAmount) || 0;
        if ((Number(row.amount) || 0) > max) {
          this.$message.error('核销金额不能大于开票金额')
          this.$set(row, 'amount', max)
        }
      },
      delInvoice(i) {
        this.invoiceList.rows.splice(i, 1)
      },
      saveInvoiceList() {
        let row = this.writeOffData[this.invoiceList.pageIndex].reiData[this.invoiceList.rowIndex]
        let rows = this.invoiceList.rows
        this.$set(row, 'invoices', rows)
        let sum = 0;
        rows.forEach(e => {
          sum += Number(e.amount) || 0
        })
        this.$set(row, 'invoiceNum', rows.map(e => e.no).filter(e => !!e).join(','))
        this.$set(row, 'documentsNum', rows.length || 1)
        this.$set(row, 'amounts', sum)
        this.invoiceList.visible = false
        this.complete();
      },
      invoicePreview(row) {
        let url = this.filePath2Url(row.fileUrl)
        if (!url) {
          this.$message.warning('该文件没有预览地址')
          return
        }
        window.open(url)
      },
      downloadInvoice(row) {
        let url = this.filePath2Url(row.fileUrl)
        if (!url) {
          this.$message.warning('该文件没有下载地址')
          return
        }
        this.down(url, row.fileName || row.no || 'invoice')
      },
      //财务审核：汇总所有报销单行的发票凭证（只读查看）
      openAllInvoiceList() {
        let rows = [];
        this.writeOffData.forEach((page, p) => {
          (page.reiData || []).forEach((row, r) => {
            (row.invoices || []).forEach(inv => {
              rows.push(Object.assign({}, inv, {
                _pageNo: p + 1,
                _rowNo: r + 1,
                _subject: row.reimbursementContent || '',
              }))
            })
          })
        })
        if (!rows.length) {
          this.$message.warning('当前报销单没有发票凭证')
          return
        }
        this.allInvoiceList.rows = rows;
        this.allInvoiceList.visible = true;
      },
      allInvoiceSum(field) {
        let s = 0
        this.allInvoiceList.rows.forEach(e => {
          s += Number(e[field]) || 0
        })
        return s
      },
      filePath2Url(path) {
        if (!path) return ''
        if (path.indexOf('http') == 0) return path
        return this.imgHead + path
      },
      //把 PDF 凭证逐页渲染成 png 图片，便于与其它发票图片一起用 html 方式打印
      pdfToImgList(url) {
        return this.loadPdfDocument(url).then(doc => {
          if (!doc) return [];
          let tasks = [];
          for (let i = 1; i <= doc.numPages; i++) {
            tasks.push(doc.getPage(i).then(page => {
              //打印清晰度：按纸张约250dpi选渲染倍率（A4目标宽约2200px），最低2倍、封顶4倍防止内存过大
              //之前固定 scale:2 时 A4 仅1190px宽，打印到纸上约144dpi，文字会发虚
              let base = page.getViewport({
                scale: 1
              });
              let printScale = Math.min(4, Math.max(2, Math.ceil(2200 / base.width)));
              let viewport = page.getViewport({
                scale: printScale
              });
              let canvas = document.createElement('canvas');
              canvas.width = viewport.width;
              canvas.height = viewport.height;
              return page.render({
                canvasContext: canvas.getContext('2d'),
                viewport
              }).promise.then(() => canvas.toDataURL('image/png'));
            }));
          }
          return Promise.all(tasks).catch(err => {
            console.error('[PDF凭证] 渲染失败', url, err);
            return [];
          });
        });
      },
      //加载 PDF 文档：统一先自行抓取字节流（部分服务端对 pdfjs 直连的 Range/Accept 请求不友好），
      //经 patchPdfGridLines 修补表格线框问题后，以字节流方式交给 pdfjs 解析
      loadPdfDocument(url) {
        let tryLoad = (src) => new Promise(resolve => {
          try {
            pdfViewer.createLoadingTask(src).promise.then(resolve).catch(err => {
              console.error('[PDF凭证] 加载失败', url, err && (err.message || err));
              resolve(null);
            });
          } catch (e) {
            console.error('[PDF凭证] 加载异常', url, e);
            resolve(null);
          }
        });
        let fetchBytes = (opts) => fetch(url, opts).then(res => {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.arrayBuffer();
        }).then(buf => new Uint8Array(buf));
        return fetchBytes({
            credentials: 'same-origin'
          })
          .catch(err => {
            console.warn('[PDF凭证] 直连抓取失败，尝试携带凭证', url, err && (err.message || err));
            return fetchBytes({
              credentials: 'include'
            });
          })
          .catch(err => {
            console.warn('[PDF凭证] 携带凭证抓取失败，尝试免凭证', url, err && (err.message || err));
            return fetchBytes({
              credentials: 'omit'
            });
          })
          .then(bytes => patchPdfGridLines(bytes))
          .then(bytes => tryLoad({
            data: bytes,
            cMapUrl: PDF_CMAP_URL,
            cMapPacked: true
          }))
          .catch(err => {
            console.error('[PDF凭证] 抓取失败', url, err && (err.message || err));
            return null; // 与旧逻辑一致：加载失败不阻塞其它凭证打印
          });
      },
      //批量打印：逐个获取核销单内容，全部就绪后合并
      GetWriteoffDetailBatch() {
        this.loading = true;
        let ids = this.writeOffIds;
        let results = new Array(ids.length).fill(null);
        let failed = []; //加载失败的报销单（按勾选序号），合并时统一提示，避免静默丢单
        let loaded = 0;
        let finished = false;
        //所有请求无论成败都必须收敛到一次合并，避免页面一直停在 loading 空白状态
        const finish = () => {
          if (finished) return;
          finished = true;
          try {
            this.mergeBatchWriteoff(results, failed);
          } catch (e) {
            console.error(e);
            this.loading = false;
            this.$message.error('批量打印数据加载失败');
          }
        };
        ids.forEach((wid, idx) => {
          xz.GetWriteoffDetail({
            busiId: wid,
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype
          }).then(res => {
            if (res && res.status == 'ok') {
              results[idx] = res.data;
            } else {
              failed.push('第' + (idx + 1) + '张：' + ((res && res.msg) || '接口返回异常'));
            }
          }).catch(() => {
            //网络层失败原来被静默吞掉，导致该张报销单直接从打印结果里消失且无任何提示
            failed.push('第' + (idx + 1) + '张：网络请求失败');
          }).then(() => {
            loaded++;
            if (loaded == ids.length) finish();
          });
        });
      },
      //批量打印：合并各核销单的报销内容到同一组 writeOffData，每页携带各自表头信息
      mergeBatchWriteoff(results, failed) {
        failed = failed || [];
        let valid = results.filter(Boolean);
        if (valid.length == 0) {
          this.loading = false;
          if (failed.length) {
            this.$message.error('以下报销单未并入打印：' + failed.join('；'));
          }
          return;
        }
        //第一个单据作为公共默认（qrcode/日期/报销人兜底）
        let d0 = valid[0];
        this.reiForm = d0;
        this.$set(this.reiForm, 'userId', Cookies.get("userid-b"));
        this.$set(this.reiForm, 'roleType', localStorage.loginRoletype);
        let pageSets = new Array(valid.length);
        let fetched = 0;
        let assembled = false;
        const assemble = () => {
          if (assembled) return;
          assembled = true;
          let pages = pageSets.reduce((a, b) => a.concat(b || []), []);
          //凭证类型为「纸质」的报销单（连同其发票凭证）排到最前；稳定排序，组内保持原顺序
          pages = pages.slice().sort((a, b) => ((a.voucherType == '纸质' ? 0 : 1) - (b.voucherType == '纸质' ? 0 : 1)));
          //补齐无纸化报销单的新字段（历史数据兼容）并保留每页表头
          this.writeOffData = pages.map(item => {
            return {
              companyName: item.companyName || '',
              depName: item.depName || '',
              AdvanceNum: item.AdvanceNum || '',
              voucherType: item.voucherType || '电子',
              reimbUserName: item.reimbUserName || (item._writtenName || '') || '',
              collapsed: false,
              reiData: (item.reiData || []).map(row => {
                return Object.assign({
                  invoices: []
                }, row)
              }),
              _hdr: item._hdr || {},
              _qrcodeUrl: item._qrcodeUrl || '',
              _reimbTime: item._reimbTime || '',
              _writtenName: item._writtenName || ''
            }
          });
          if (this.writeOffData.length == 0) {
            this.addPage()
          }
          this.loading = false;
          this.complete();
          if (failed.length) {
            //加载失败/内容为空的报销单不会出现在打印结果里，明确提示避免误以为已全部打印
            this.$message({
              type: 'error',
              message: '以下报销单未并入打印：' + failed.join('；'),
              duration: 8000
            });
          }
          //数据就绪后自动触发打印（延时等待 complete() 内 100ms 后重建 rei）
          if (this.autoPrint) {
            setTimeout(() => {
              this.printClick('printBox', '');
            }, 500);
          }
        };
        valid.forEach((d, i) => {
          //先把本单的报销内容解析出来，表头请求失败也不影响内容展示
          let wd = [];
          try {
            wd = eval(d.reimbContent) || [];
          } catch (e) {
            wd = [];
          }
          if (!wd.length) {
            //内容为空或解析失败：该单的所有报销页都会缺失，必须提示而不是静默丢页
            failed.push('第' + (results.indexOf(d) + 1) + '张：报销内容为空或解析失败');
          }
          //逐单获取各自暂支单表头，保证每张报销单的 付款/日期/报销人 正确
          //20s 超时兜底：表头接口挂起也不能阻塞整批合并，否则永远停在加载中
          Promise.race([
            xz.GetAdvancesDetail(Object.assign({}, this.listQuery, {
              busiId: d.advanceId,
              userId: Cookies.get("userid-b"),
              roleType: localStorage.loginRoletype
            })),
            new Promise(resolve => setTimeout(() => resolve(null), 20000))
          ]).then(r2 => {
            let hdr = (r2 && r2.status == 'ok' && r2.data && r2.data.adVerifs) ? r2.data.adVerifs : {};
            wd.forEach(p => {
              p._hdr = hdr;
              p._qrcodeUrl = d.qrcodeUrl || '';
              p._reimbTime = d.reimbTime || '';
              p._writtenName = d.writtenName || '';
            });
          }).catch(() => {}).then(() => {
            //每个单据无论成功失败都要落位并递增，保证最终一定能合并
            pageSets[i] = wd;
            fetched++;
            if (fetched == valid.length) assemble();
          });
        });
      },
      complete() {
        this.syncRows();
        if (this.logData.length > 0 || this.type != 'add') {
          this.getTotalAmounts();
          setTimeout(() => {
            this.rei = JSON.parse(JSON.stringify(this.writeOffData));
            let data2 = {
              occurDate: '', //发生日期
              reimbursementContent: '', //报销内容
              documentsNum: '', //单据张数
              invoiceNum: '', //发票号码
              amounts: '', //金额
              remark: '', //备注
              invoiceType: '', //发票类型
              projectName: '', //项目名称
            }
            this.rei.forEach((element, index) => {
              if (this.type == 'add' && !element.AdvanceNum) {
                xz.GetAdvOrderCode('k').then(res => {
                  if (res.status == 'ok') {
                    this.$set(element, 'AdvanceNum', res.data)
                    this.$set(this.writeOffData[index], 'AdvanceNum', res.data)
                  }
                })
              }
              let l = element.reiData.length;
              this.$set(element, 'checked', true)
              for (var j = 0; j < 6 - l; j = j + 1) {
                element.reiData.push(data2)
              }
            });
          }, 100);
        } else {
          // this.$message.warning('暂无日志记录，不能填写报销单')
        }
      },
      getNum(num, t) {
        if (num != undefined && num) {
          num = Number(num)
          let result = '';
          let c = '';
          switch (t) {
            case 'j':
              c = num.toFixed(2).split('.')[1]
              result = parseInt((c % 100) / 10)
              break;
            case 'f':
              c = num.toFixed(2).split('.')[1]
              result = parseInt(c % 10)
              break;
            case 'g':
              result = parseInt(num % 10)
              break;
            case 's':
              if (num < 10) {
                result = ''
              } else {
                result = parseInt((num % 100) / 10)
              }
              break;
            case 'b':
              if (num < 100) {
                result = ''
              } else {
                result = parseInt((num % 1000) / 100)
              }
              break;
            case 'q':
              if (num < 1000) {
                result = ''
              } else {
                result = parseInt((num % 10000) / 1000)
              }
              break;
            case 'w':
              if (num < 10000) {
                result = ''
              } else {
                result = parseInt((num % 100000) / 10000)
              }
              break;
            case 'sw':
              if (num < 100000) {
                result = ''
              } else {
                result = parseInt((num % 1000000) / 100000)
              }
              break;
            case 'bw':
              if (num < 1000000) {
                result = ''
              } else {
                result = parseInt((num % 10000000) / 1000000)
              }
              break;
          }
          // let n2 = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
          return result
        }
      },
      //获取每张报销单的总金额
      getTotalAmounts() {
        this.writeOffData.forEach((element, index) => {
          let sum = 0;
          element.reiData.forEach(e => {
            // sum = sum + Number(e.amounts)
            sum = math.format(
              math.add(
                math.bignumber(sum), math.bignumber(Number(e.amounts))
              )
            )
          });
          this.$set(element, 'sum', sum)
          if (index == this.writeOffData.length - 1) {
            setTimeout(() => {
              this.getTotalAmounts2()
            }, 200);
          }
        });
      },
      //获取总金额
      getTotalAmounts2() {
        let sum2 = 0;
        this.rei.forEach(element => {
          // sum2 = sum2 + Number(element.sum)
          sum2 = math.format(
            math.add(
              math.bignumber(Number(sum2)), math.bignumber(Number(element.sum))
            )
          )
        });
        this.reiForm.writtenAmount = sum2;
      },
      //返回
      goBack() {
        window.close()
      },
      //保存报销单
      confirmSave(type) {
        if (this.logData.length > 0) {
          this.complete();
          // if (this.logAmount != this.reiForm.writtenAmount) {
          //   this.$message({
          //     type: 'warning',
          //     message: '报销单总金额必须等于日志总金额，当前报销单总金额为 ' + this.reiForm.writtenAmount + ' 元，日志总金额为' + this.logAmount + ' 元',
          //     duration: 5000
          //   })
          // } else {
          let canSave = true;
          let require = true;
          let require2 = true;
          let noInvoice = ''; //凭证类型为「电子」但存在未上传发票的报销单编号
          // let invoiceNum = this.writeOffData[0].reiData[0].invoiceNum
          this.writeOffData.forEach((element, index) => {
            element.reiData.forEach((e, i) => {
              // if (!e.invoiceNum) {
              //   require = false;
              // }
              if (!e.reimbursementContent) {
                require2 = false;
              }
              //电子凭证必须有电子发票文件，无票行只能选「纸质」
              if (element.voucherType == '电子' && !(e.invoices && e.invoices.length) && !noInvoice) {
                noInvoice = '报销单' + (index + 1);
              }
              // if (e.invoiceNum == invoiceNum && index != 0) {
              //   canSave = false;
              // }
              if (index == this.writeOffData.length - 1 && i == element.reiData.length - 1) {
                // if (require && canSave) {
                //   this.confirmSave2(type)
                // } else if (!require) {
                //   this.$message.error('发票号码是必填项！请填写发票号码')
                // } else if (!require2) {
                //   this.$message.error('报销内容是必填项！请选择报销内容')
                // } else if (require && !canSave) {
                //   this.$message.error('填写的发票号码出现重复，请检查')
                // }
                if (!require2) {
                  this.$message.error('报销内容是必填项！请选择报销内容')
                } else if (noInvoice) {
                  this.$message.error(noInvoice + '的凭证类型为「电子」，每一行都必须上传发票凭证；无票的行请改选「纸质」')
                } else {
                  setTimeout(() => {
                    this.confirmSave2(type)
                  }, 200);
                }
              }
            });
          });
          // }
        } else {
          this.$message.warning('没有日志记录，不能保存')
        }
      },
      confirmSave2(type) {
        this.$refs["bankForm"].validate((valid) => {
          if (valid) {
            let arr = [];
            this.logData.forEach((element, index) => {
              arr.push(element.id)
              if (index == this.logData.length - 1) {
                this.reiForm.advanceIds = arr.toString();
                this.isBtnLoading = true;
                // if (this.reiForm.depName) {
                //   this.reiForm.depName = this.reiForm.depName.toString();
                // }
                // if (this.delData.length > 0) {
                //   this.writeOffData.concat(this.delData)
                // }
                this.complete();
                if (this.companyName && this, this.tabName == '财务审核') {
                  this.$set(this.reiForm, 'ReimbCompanyName', this.companyName)
                }
                this.reiForm.reimbContent = this.writeOffData;
                xz.AdvanceFun(this.reiForm, 'addUpdataLogVerif').then(res => {
                  if (res.status == 'ok') {
                    //发票-单据关联由后端在保存核销单时自动同步，无需前端再调
                    if (type == '2') {
                      this.$message.success('保存成功')
                      this.isSubmit = true;
                      setTimeout(() => {
                        this.goBack();
                      }, 1000);
                    } else if (type == '3') {
                      this.resId = res.data;
                      this.confirmSubmit();
                    } else {
                      this.Approve(type)
                    }
                    this.isBtnLoading = false;
                  } else {
                    this.$message.error(res.msg);
                    this.isBtnLoading = false;
                  }
                })
              }
            });
          }
        })
      },
      confirmSubmit() {
        let data = {
          id: this.resId,
          type: '2', //1.为暂支，2为日志
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.SubmitWriteoff(data).then(res => {
          if (res.status == 'ok') {
            this.isBtnLoading = false;
            this.$message.success('提交报销成功');
            this.isSubmit = true;
            setTimeout(() => {
              this.goBack();
            }, 1000);
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      //审批
      // handelApprove(results) {
      //   this.confirmSave('');
      //   this.isBtnLoading = true;
      //   setTimeout(() => {
      //     this.Approve(results)
      //   }, 200);
      // },
      Approve(results) {
        this.isBtnLoading = true;
        let data = {
          type: this.tabName == '部门审核' ? '3' : '4',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          results,
          remark: this.reiForm.applyRemark,
          busiId: this.id
        }
        xz.VerifiDepartAudit(data).then(res => {
          if (res.status == 'ok') {
            this.$message.success('操作成功！');
            this.isBtnLoading = false;
            this.isSubmit = true;
            setTimeout(() => {
              this.goBack();
            }, 1000);
          } else {
            this.$message.error(res.msg)
            this.isBtnLoading = false;
          }
        })
      },
      //获取审批流
      GetApprovalList() {
        let data = {
          type: this.tabName == '部门审核' ? '1' : '2',
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          busiId: this.writeOffId
        }
        xz.GetApprovalList(data).then(res => {
          if (res.status == 'ok') {
            this.WorkerList = res.data;
            if (this.WorkerList.length > 0) {
              let last = this.WorkerList[this.WorkerList.length - 1]
              this.WorkerList[this.WorkerList.length - 1].title = last.userName
            }
          } else {
            this.WorkerList = [];
            this.$message.error(res.msg)
          }
        })
      },
      //数字转中文大写
      numberToChinese(money) {
        // 汉字的数字
        let cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
        // 基本单位
        let cnIntRadice = ['', '拾', '佰', '仟']
        // 对应整数部分扩展单位
        let cnIntUnits = ['', '万', '亿', '兆']
        // 对应小数部分单位
        let cnDecUnits = ['角', '分', '厘', '毫']
        // 整数金额时后面跟的字符
        let cnInteger = '整'
        // 整型完以后的单位
        let cnIntLast = '元'
        // 最大处理的数字
        let maxNum = 999999999999999.9999
        // 金额整数部分
        let integerNum
        // 金额小数部分
        let decimalNum
        // 输出的中文金额字符串
        let chineseStr = ''
        // 分离金额后用的数组，预定义
        let parts
        if (money === '') {
          return ''
        }
        money = parseFloat(money)
        if (money >= maxNum) {
          // 超出最大处理数字
          return ''
        }
        if (money === 0) {
          chineseStr = cnNums[0] + cnIntLast + cnInteger
          return chineseStr
        }
        // 转换为字符串
        money = money.toString()
        if (money.indexOf('.') === -1) {
          integerNum = money
          decimalNum = ''
        } else {
          parts = money.split('.')
          integerNum = parts[0]
          decimalNum = parts[1].substr(0, 4)
        }
        // 获取整型部分转换
        if (parseInt(integerNum, 10) > 0) {
          let zeroCount = 0
          let IntLen = integerNum.length
          for (let i = 0; i < IntLen; i++) {
            let n = integerNum.substr(i, 1)
            let p = IntLen - i - 1
            let q = p / 4
            let m = p % 4
            if (n === '0') {
              zeroCount++
            } else {
              if (zeroCount > 0) {
                chineseStr += cnNums[0]
              }
              // 归零
              zeroCount = 0
              chineseStr += cnNums[parseInt(n)] + cnIntRadice[m]
            }
            if (m === 0 && zeroCount < 4) {
              chineseStr += cnIntUnits[q]
            }
          }
          chineseStr += cnIntLast
        }
        // 小数部分
        if (decimalNum !== '') {
          let decLen = decimalNum.length
          for (let i = 0; i < decLen; i++) {
            const n = decimalNum.substr(i, 1)
            if (n !== '0') {
              chineseStr += cnNums[Number(n)] + cnDecUnits[i]
            }
          }
        }
        if (chineseStr === '') {
          chineseStr += cnNums[0] + cnIntLast + cnInteger
        } else if (decimalNum === '') {
          chineseStr += cnInteger
        }
        return chineseStr
      },
      GetLogMonthsAdvanceList() {
        this.logData = [];
        xz.AdvanceFun(this.listQuery, 'GetLogMonthsAdvanceList').then(res => {
          if (res.status == 'ok') {
            this.logAmount = 0;
            this.logData = res.data.data;
            if (res.data.data.length > 0) {
              this.logData.forEach(element => {
                // this.logAmount = this.logAmount + Number(element.totalFees);
                this.logAmount = math.format(
                  math.add(
                    math.bignumber(Number(this.logAmount)), math.bignumber(Number(element.totalFees))
                  )
                )
              });
            }
          } else {
            this.logData = [];
          }
        })
      },
      changeUser(val) {
        console.log(val)
        this.listQuery.applyUserNameId = val.userid;
        // this.listQuery.applyUserName = val.username;
        this.reiForm.writtenName = val.username;
        this.reiForm.WrittenId = val.userid;
        if (this.type == 'add') {
          this.GetAdvPaymenCard();
        }
        if (this.listQuery.applyUserNameId && this.listQuery.applyMonth) {
          this.GetLogMonthsAdvanceList();
        }
      },
      changeApplyMonth() {
        if (this.listQuery.applyUserNameId && this.listQuery.applyMonth) {
          this.GetLogMonthsAdvanceList();
        }
      },
      getLogData() {
        let data = {
          ids: this.reiForm.advanceIds,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        }
        this.logData = [];
        xz.AdvanceFun(data, 'GetAdvancesListById').then(res => {
          if (res.status == 'ok') {
            this.logAmount = 0;
            this.logData = res.data;
            if (res.data.length > 0) {
              this.logData.forEach(element => {
                // this.logAmount = this.logAmount + Number(element.totalFees);
                this.logAmount = math.format(
                  math.add(
                    math.bignumber(Number(this.logAmount)), math.bignumber(Number(element.totalFees))
                  )
                )
              });
            }
          } else {
            this.logData = [];
          }
        })
      },
      //获取报销人银行卡信息
      GetAdvPaymenCard() {
        xz.GetAdvPaymenCard(this.listQuery.applyUserNameId).then(res => {
          if (res.status == 'ok' && res.data) {
            this.reiForm.depositBank = res.data.depositBank;
            this.reiForm.bankAccount = res.data.bankAccount;
          } else {
            this.reiForm.depositBank = '';
            this.reiForm.bankAccount = '';
          }
        })
      },
      changeDep(val) {
        // console.log(val.toString())
        this.depName = val[val.length - 1]
      },
      //获取暂支报销详情
      GetWriteoffDetail() {
        this.loading = true;
        let data = {
          busiId: this.writeOffId,
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype
        }
        xz.GetWriteoffDetail(data).then(res => {
          if (res.status == 'ok') {
            this.reiForm = res.data;
            this.$set(this.reiForm, 'userId', Cookies.get("userid-b"));
            this.$set(this.reiForm, 'roleType', localStorage.loginRoletype);
            this.writeOffData = eval(res.data.reimbContent) || [];
            //补齐无纸化报销单的新字段（历史数据兼容）
            this.writeOffData = this.writeOffData.map(item => {
              return {
                companyName: item.companyName || '',
                depName: item.depName || '',
                AdvanceNum: item.AdvanceNum || '',
                voucherType: item.voucherType || '电子',
                reimbUserName: item.reimbUserName || this.reiForm.writtenName || '',
                entityName: item.entityName || '',
                entityNameFlag: item.entityNameFlag || '', //我方公司主体不合格标记（后端按发票识别内容写入）
                collapsed: false,
                reiData: (item.reiData || []).map(row => {
                  return Object.assign({
                    invoices: []
                  }, row)
                })
              }
            })
            if (this.writeOffData.length == 0) {
              this.addPage()
            }
            this.getLogData();
            this.complete();
            this.loading = false;
            //数据就绪后自动触发打印（批量打印场景）
            if (this.autoPrint) {
              setTimeout(() => {
                this.printClick('printBox', '');
              }, 800);
            }
            // this.fileList = res.data.materAcces;
          } else {
            this.$message.error(res.msg);
            this.loading = false;
          }
        })
      },
      //advid获取busid
      GetJbBusiaAdvLogWritFinans() {
        xz.GetJbBusiaAdvLogWritFinans(this.id).then(res => {
          if (res.status == 'ok') {
            this.writeOffId = res.data.advanceId;
            this.GetWriteoffDetail();
          }
        })
      },
      //判断是否重复
      judgeRepeat(row, index) {
        if (row.invoiceNum) {
          xz.GetCheckinvoiceNum(this.writeOffId, row.invoiceNum).then(res => {
            if (res.status == 'ok') {} else {
              this.$set(row, 'invoiceNum', '');
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 5000
              })
            }
          })
        }
      },
      //判断是否重复
      judgeRepeat2(num, index) {
        if (num) {
          xz.GetCheckinvoiceNum(this.writeOffId, num).then(res => {
            if (res.status == 'ok') {} else {
              this.$set(this.invoiceNumList[index], 'num', '');
              this.$message({
                type: 'error',
                message: res.msg,
                duration: 5000
              })
            }
          })
        }
      },
      //添加多个发票号码
      addInvoiceNum(row, index) {
        this.info = row;
        if (row.invoiceNum) {
          let arr = row.invoiceNum.split(',');
          this.invoiceNumList = [];
          arr.forEach(element => {
            let data = {
              num: element
            }
            this.invoiceNumList.push(data)
          });
        } else {
          this.invoiceNumList = [{
            num: ''
          }]
        }
        this.showAddInvoiceNum = true;
      },
      //添加一行发票号码
      addNewInvoiceNum() {
        let data = {
          num: ''
        }
        this.invoiceNumList.push(data)
      },
      delInvoiceNum(index) {
        this.invoiceNumList.splice(index, 1)
      },
      confirmAddInvoiceNum() {
        let arr = [];
        this.invoiceNumList.forEach(element => {
          if (element.num) {
            arr.push(element.num)
          }
        });
        this.$set(this.info, 'invoiceNum', arr.toString());
        this.showAddInvoiceNum = false;
      },
      importInvoice() {
        this.invoiceList.visible = false;
        this.showInvoiceImport = true;
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 20px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }


  .infoBox {
    // width: 1050px;
    background: #E8F7F7;
    padding: 10px 20px;

  }

  .infoTitle {
    font-size: 14px;
    font-weight: 600;
    // text-wrap: nowrap;
    line-height: 32px;
    margin-right: 10px;
  }

  .basicInfo {
    flex-wrap: wrap;
    // width: 900px;
  }

  .infoItem {
    color: #000;
    font-size: 13px;
    min-width: 140px;
    line-height: 32px;
    margin-right: 30px;
  }

  .incInfo {
    margin-top: 10px;
  }

  .readInfo {
    padding: 0 30px;
    display: flex;
    flex-wrap: wrap;
  }

  .readInfoItem {
    width: 240px;
    margin-bottom: 15px;
    font-size: 14px;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .down {
    color: #409EFF;
    margin-right: 15px;
  }

  .cotName {
    margin: 0 10px;
    max-width: 5em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: #409EFF;
  }

  .verRecBox {
    margin: 20px 0;
  }

  .Reititle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .reimbursementBox {
    /* color: red; */
    // width: 1100px;
    color: #000;
    margin-bottom: 30px;
    padding-top: 10px;
  }

  /* 发票凭证列表弹窗 */
  .invDlgTitle {
    font-size: 16px;
    font-weight: 600;
  }

  .invHeaderCard {
    background: #F5F8FC;
    border-radius: 6px;
    padding: 12px 16px;
    margin-bottom: 12px;
    font-size: 13px;
    color: #606266;
  }

  .invHeaderTop span {
    margin-right: 8px;
  }

  .invHeaderTop .sep {
    color: #C0C4CC;
  }

  .invHeaderSum {
    margin-top: 8px;
    color: #303133;
  }

  .invHint {
    background: #FFF8EC;
    border-radius: 6px;
    padding: 10px 14px;
    font-size: 13px;
    color: #B88230;
    margin-bottom: 14px;
  }

  .invHint i {
    margin-right: 6px;
    color: #E6A23C;
  }

  .invCardList {
    max-height: 360px;
    overflow-y: auto;
  }

  .invCard {
    display: flex;
    align-items: center;
    padding: 16px;
    border: 1px solid #F0F2F5;
    border-radius: 8px;
    margin-bottom: 12px;
    background: #fff;
  }

  .invBadge {
    width: 40px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    background: #ECF5FF;
    color: #409EFF;
    border-radius: 8px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .invMain {
    flex: 1;
    margin: 0 14px;
    min-width: 0;
  }

  .invSeller {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 6px;
  }

  .invMeta {
    font-size: 12px;
    color: #909399;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .invAmount {
    display: flex;
    align-items: center;
    flex-shrink: 0;
  }

  .invAmount .el-input {
    width: 90px;
  }

  .invAmount>>>.el-input__inner {
    border-color: #409EFF;
    color: #303133;
    text-align: right;
  }

  .invOrig {
    margin-left: 8px;
    color: #909399;
    font-size: 12px;
  }

  .invOps {
    flex-shrink: 0;
    margin-left: 12px;
  }

  .invEmpty {
    text-align: center;
    color: #909399;
    padding: 40px 0;
  }

  .reiTableBox {
    padding: 10px 30px 20px 20px;
    max-width: 1100px;
  }

  .reiBcg {
    background: #FEF8E4;
  }

  .reiTableTitle {
    font-size: 14px;
    justify-content: space-around;
  }

  .reiTableBot {
    width: 800px;
    justify-content: center;
    font-size: 14px;
  }

  .reiTop {
    display: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
  }

  .reiRnumber {
    font-size: 16px;
    padding-left: 10px;
    font-weight: bold;
  }

  .reiType {
    font-size: 16px;
    padding-left: 10px;
    font-weight: bold;
  }

  .reimbursementTitle {
    text-align: center;
    font-weight: bold;
    margin-bottom: 3px;
    font-size: 24px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .centerTitle {
    // width: 300px;
    margin-bottom: 5px;
    font-size: 20px;
  }

  .centerTitle hr {
    margin: 10px auto 0;
  }

  .reiTopRight {
    // width: 300px;
  }

  .accountBox {
    font-size: 14px;
  }

  .qrcode {
    // margin-left: 80px;
    width: 70px;
    height: 70px;
  }

  .qrcode img {
    width: 70px;
    height: 70px;
  }

  .reiInfo {
    font-size: 14px;
    white-space: nowrap;
  }

  .answer {
    border-bottom: 1px solid #000;
    padding: 0 15px 3px;
    margin: 0 10px;
    min-width: 100px;
  }

  .answer2 {
    border-bottom: 1px solid #000;
    padding: 0 5px;
    margin: 0 3px;
  }

  .reiDate {
    padding-right: 55px;
  }

  .reiBot {
    font-size: 14px;
    margin-top: 5px;
    font-weight: bold;
    white-space: nowrap;
  }

  .reiBotInfo {
    min-width: 80px;
  }

  .tabtop13 {
    margin-top: 5px;
  }

  .tabtop13 td {
    background-color: #ffffff;
    height: 30px;
    line-height: 150%;
  }

  .tabtop15 td {
    padding: 8px;
    word-break: break-word;
    font-size: 14px;
  }

  .font-center {
    text-align: center
  }

  .biaoti {
    font-family: 微软雅黑;
    font-size: 26px;
    font-weight: bold;
    border-bottom: 1px dashed #CCCCCC;
  }

  .titfont {
    font-family: 微软雅黑;
    font-size: 16px;
    font-weight: bold;
    // background: url(../images/ico3.gif) no-repeat 15px center;
  }

  .bttit {
    background: #F6F6F6 !important;
  }

  .tabtxt2 {
    font-family: 微软雅黑;
    font-size: 14px;
    font-weight: bold;
    text-align: right;
    padding-right: 10px;
  }

  .tabtxt3 {
    font-family: 微软雅黑;
    font-size: 14px;
    padding-left: 15px;
    color: #000;
    margin-top: 10px;
    margin-bottom: 10px;
    line-height: 20px;
  }

  .printBox {
    width: 800px;
    // padding-top: 100px;
  }

  .printBox table {
    border: #000 2px solid;
    border-collapse: collapse;
  }

  table td,
  table th {
    border: #000 1px solid;
  }

  .btnBox {
    margin-top: 20px;
    padding: 20px 0 30px 0;
    width: 600px;
    display: flex;
    justify-content: center;
  }

  .accountName {
    min-width: 100px;
  }

  .logAmount {
    margin-top: 15px;
    font-size: 16px;
    padding-left: 15px;
  }

  // .reiItem {
  //   margin: 100px 0;
  // }

  .mt {
    margin-top: 300px;
  }

  .pb {
    page-break-after: always;
  }

  .writeOffTable {
    margin-top: 10px;
    width: 900px;
    background-color: #fff;
    padding: 8px 0;
    line-height: 40px;
  }

  .reiTableBox table td,
  .reiTableBox table th {
    border: #d2d2d2 1px solid !important;
  }

  .reiTableBox table {
    border: #d2d2d2 1px solid !important;
  }

  .reiTableBox_title {
    background: #f6f6f6;
  }

  .required {
    color: red;
    margin-right: 3px;
  }

  /* ===== 无纸化报销单 ===== */
  .wzStat {
    margin-left: 15px;
    font-size: 12px;
    color: #606266;
  }

  .wzFormBox {
    margin-top: 10px;
  }

  .wzForm {
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    margin-bottom: 12px;
    background: #fff;
    overflow: hidden;
  }

  .wzFormHead {
    padding: 8px 12px;
    background: #f5f7fa;
    border-bottom: 1px solid #e4e7ed;
  }

  .wzFormNo {
    font-weight: 600;
    margin: 0 8px 0 6px;
  }

  .wzFormMeta {
    font-size: 12px;
    color: #909399;
    margin-left: 15px;
  }

  .wzMetaRow {
    padding: 10px 12px 0;
    font-size: 13px;
    color: #606266;
  }

  .wzTable {
    margin: 10px 12px;
    width: calc(100% - 24px);
  }

  .wzInvoiceNos {
    display: inline-block;
    max-width: 140px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }

  .wzTip {
    margin-left: 15px;
    font-size: 12px;
    color: #c0c4cc;
  }

  /* 电子凭证三项不合格：行内警示图标 */
  .wzWarnIcon {
    margin-left: 4px;
    color: #E6A23C;
    font-size: 15px;
    flex-shrink: 0;
  }

  /* 提示行换行 */
  .flexW {
    flex-wrap: wrap;
  }

  .wzUploadBox {}

  .wzUpload {
    width: 100%;
  }

  .wzUploadManual {
    margin-top: 12px;
    height: 120px;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #19bd92;
    cursor: pointer;
    font-size: 14px;

    i {
      font-size: 28px;
      margin-bottom: 8px;
    }

    &:hover {
      border-color: #19bd92;
    }
  }

  .wzResultTitle {
    font-weight: 600;
    margin: 6px 0;
  }

  .wzResultTitle2 {
    color: #F56C6C;
  }

  .printNoTxt {
    display: inline-block;
    padding: 3px 12px;
    margin-left: 10px;
    border-radius: 14px;
    background: linear-gradient(90deg, #409EFF, #79bbff);
    color: #fff;
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    box-shadow: 0 2px 6px rgba(64, 158, 255, .35);
    cursor: default
  }
</style>
<style>
  .page_tePaymentDtl .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePaymentDtl .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_tePaymentDtl .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_tePaymentDtl .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_tePaymentDtl .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_tePaymentDtl .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_tePaymentDtl .demandForm .el-form-item__label {
    color: #999;
  }

  .page_tePaymentDtl .demandForm .el-form--inline .el-form-item {
    width: 270px;
    margin-right: 0;
  }

  .page_tePaymentDtl .demandForm .el-form-item {
    margin-bottom: 0;
  }

  .page_tePaymentDtl .el-form-item {
    margin-bottom: 10px;
  }

  .reiTableBox .el-form-item {
    margin-bottom: 0;
  }

  .page_tePaymentDtl .el-form-item__error {
    top: 89%;
  }
</style>